// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

/* Services */
angular.module('iteroServices', ['ngResource']).factory('ProductInfo',
        [
            '$resource', 'babelFilter', 'numberFilter', '$filter', function($resource, babelFilter, numberFilter, $filter) {
                var productInfoService = {};

                var createLookup = function(collection, propertyName) {
                    var lookup = {};
                    for (var i = 0; i < collection.length; i++) {
                        var key0 = collection[i][propertyName];
                        lookup[key0] = collection[i];
                    }
                    return function(key) {
                        return lookup[key];
                    };
                };

                var compareComponentsByName = function(a, b) {
                    //compare translated text with babelFilter prevent cody duplication
                    var aText = babelFilter(a.Name).toLowerCase();
                    var bText = babelFilter(b.Name).toLowerCase();
                    if (aText < bText)
                        return -1;
                    if (aText > bText)
                        return 1;
                    return 0;
                }

                var createMultiLookup = function(collection, propertyName) {
                    var lookup = {};
                    for (var i = 0; i < collection.length; i++) {
                        var key0 = collection[i][propertyName];
                        if (!(key0 in lookup))
                            lookup[key0] = [];
                        lookup[key0].push(collection[i]);
                    }
                    return function(key) {
                        if (!(key in lookup))
                            return [];
                        return lookup[key];
                    };
                };

                let linkPriceLists = function (priceLists) {
                    if (!priceLists)
                        return;
                    for (let i = 0; i < priceLists.length; i++) {
                        let priceList = priceLists[i];
                        priceList.ParentItems = getAllPriceListItemsForGivenPriceList(priceList, priceLists);
                    }
                };

                // JavaScript function to get all price list items for a given price list considering its parent hierarchy
                function getAllPriceListItemsForGivenPriceList(priceList, productPriceLists) {
                    const productItemsMap = new Map(); // Using Map to store unique items based on ProductId

                    // Add items from the initial price list
                    priceList.Items.forEach(item => {
                        if (!productItemsMap.has(item.ProductId)) {
                            productItemsMap.set(item.ProductId, item);
                        }
                    });
                    let runningPriceList = priceList;

                    // Traverse up the hierarchy until a parent with a price is found or no more parents exist
                    while (runningPriceList.ParentPriceListId) {
                        const parentObjectId = runningPriceList.ParentPriceListId;

                        // Find the parent price list from the collection
                        const parentPriceList = productPriceLists.find(p => p.Id === parentObjectId);
                        if (!parentPriceList) {
                            // Return all unique items collected so far
                            return Array.from(productItemsMap.values());
                        }

                        // Add items from the running price list if not already present
                        parentPriceList.Items.forEach(item => {
                            if (!productItemsMap.has(item.ProductId)) {
                                productItemsMap.set(item.ProductId, item);
                            }
                        });

                        // Move up to the next parent
                        runningPriceList = parentPriceList;
                    }
                    // Return all unique items collected
                    return Array.from(productItemsMap.values());
                }


            function processProductInfo(productInfo, callback) {
                // Sort components and discounts
                productInfo.Components = productInfo.Components.sort(compareComponentsByName);
                productInfo.Discounts = productInfo.Discounts.sort(compareComponentsByName);

                // Create lookups
                productInfo.PlanGroupById = createLookup(productInfo.PlanGroups, "Id");
                productInfo.PriceListById = createLookup(productInfo.PriceLists, "Id");
                linkPriceLists(productInfo.PriceLists);
                productInfo.PlanById = createLookup(productInfo.Plans, "Id");
                productInfo.PlanVariantById = createLookup(productInfo.PlanVariants, "Id");
                productInfo.ComponentById = createLookup(productInfo.Components, "Id");
                productInfo.TaxPolicyById = createLookup(productInfo.TaxPolicies, "Id");
                productInfo.TaxDefinitionById = createLookup(productInfo.TaxDefinitions, "Id");
                productInfo.DiscountById = createLookup(productInfo.Discounts, "Id");
                productInfo.CouponById = createLookup(productInfo.Coupons, "Id");

                // Create multi-lookups
                productInfo.ComponentsByPlanGroupId = createMultiLookup(productInfo.Components, "PlanGroupId");
                productInfo.PlansByPlanGroupId = createMultiLookup(productInfo.Plans, "PlanGroupId");
                productInfo.PlanVariantsByPlanId = createMultiLookup(productInfo.PlanVariants, "PlanId");
                productInfo.PlanVariantsByPlanGroupId = createMultiLookup(productInfo.PlanVariants, "PlanGroupId");
                productInfo.DiscountsByPlanGroupId = createMultiLookup(productInfo.Discounts, "PlanGroupId");
                productInfo.CouponsByPlanGroupId = createMultiLookup(productInfo.Coupons, "PlanGroupId");
                productInfo.PriceListsByPlanGroupId = createMultiLookup(productInfo.PriceLists, "PlanGroupId");

                // Setup helper functions
                productInfo.getDefaultTaxPolicyId = function() {
                    if (productInfo.TaxPolicies && productInfo.TaxPolicies.length === 1) {
                        return productInfo.TaxPolicies[0].Id;
                    }
                    return null;
                };

                productInfo.getPriceListItemInHierarchy = function (priceList, productId) {
                    let priceListItem = priceList?.Items.find(x => x.ProductId === productId);

                    if (!priceListItem && priceList?.ParentPriceListId) {
                        return productInfo.getPriceListItemInHierarchy(productInfo.PriceListById(priceList.ParentPriceListId), productId);
                    }

                    return priceListItem;
                };

                productInfo.getPrice = function(componentSubscription, priceList) {
                    let numberFilterPrecision = 2;
                    let priceListItem = productInfo.getPriceListItemInHierarchy(priceList, componentSubscription.ComponentId);

                    if (priceListItem == null)
                        return "No price";

                    if (componentSubscription.ProductOverride && (componentSubscription.ProductOverride.PricePerUnit || componentSubscription.ProductOverride.PricePerUnit === 0)) {
                        return numberFilter(componentSubscription.ProductOverride.PricePerUnit, numberFilterPrecision);
                    }

                    if (priceListItem.RecurringPrice.PricePerUnit) {
                        return numberFilter(priceListItem?.RecurringPrice.PricePerUnit, numberFilterPrecision);
                    }

                    if (priceListItem.RecurringPrice.DiscountScale && priceListItem.RecurringPrice.DiscountScale.Items) {
                        return numberFilter(priceListItem.RecurringPrice.DiscountScale.BasePricePerUnit, numberFilterPrecision) + " (-" +
                            priceListItem.RecurringPrice.DiscountScale.Items[0].Value + "%/-" +
                            priceListItem.RecurringPrice.DiscountScale.Items[1].Value + "%/ ...)";
                    }

                    if (priceListItem.RecurringPrice.PriceScale && priceListItem.RecurringPrice.PriceScale.Items) {
                        return numberFilter(priceListItem.RecurringPrice.PriceScale.Items[0].Value, numberFilterPrecision) + "/" +
                            numberFilter(priceListItem.RecurringPrice.PriceScale.Items[1].Value, numberFilterPrecision) + "/ ...";
                    }

                    return "Free";
                };

                productInfo.getRecurringComponentPrice = function (componentSubscription, priceListId) {
                    let priceList = productInfo.PriceListById(priceListId);
                    let price = productInfo.getPrice(componentSubscription, priceList);
                    if (price !== 'Free' && price !== 'No price') {
                        price += ` ${priceList.Currency} ${$filter('perPeriod')(productInfo.ComponentById(componentSubscription.ComponentId).FeePeriod)}`;
                    }
                    return price;
                };

                productInfo.getMeteredComponentPrice = function (meteredUsage, priceListId) {
                    let priceList = productInfo.PriceListById(priceListId);
                    let price = productInfo.getPrice(meteredUsage, priceList);
                    if (price !== 'Free' && price !== 'No price') {
                        price += ` ${priceList.Currency}`;
                    }
                    return price;
                };
                
                if (callback) {
                    callback(productInfo);
                }

                return productInfo;
            }
            
            productInfoService.get = function(callback, showHidden = false) {
                var productInfo = $resource(baseUrl + 'api/v1/productinfo/?showHidden=' + showHidden, {}, {}).get(
                    {},
                    function() {
                        processProductInfo(productInfo, callback);
                    }
                );
                return productInfo;
            };

            productInfoService.getProductInfoForContract = function(contractId, includeAllNonHidden = false, callback = null) {
                var productInfoResource = $resource(baseUrl + "api/v1/contracts/:contractId/productInfo",
                    { contractId: contractId, includeAllNonHidden: includeAllNonHidden },
                    {
                        get: {
                            method: 'GET',
                            isArray: false,
                            transformResponse: function(data) {
                                return angular.fromJson(data);
                            }
                        }
                    }
                );

                var productInfo = productInfoResource.get({}, function() {
                    processProductInfo(productInfo, callback);
                }, function(error) {
                    if (callback) {
                        callback(null, error);
                    }
                });

                return productInfo;
            };
                
                return productInfoService;
            }
        ]).factory('AccountSetup',
        [
            '$http', function($http) {
                var service = {
                    get: function(token) {
                        return $http({
                            method: 'GET',
                            url: baseUrl + 'api/v1/signup/' + token
                        });
                    },
                    save: function(token, url, data) {
                        return $http({
                            method: 'POST',
                            url: baseUrl + url + token,
                            data: data
                        });
                    }
                };
                return service;
            }
        ]).factory('AccountingExportSettings',
        [
            '$resource','$http', function($resource, $http) {
                 let factory = $resource(baseUrl + 'api/v1/accountingExportSettings/:id', {}, { update: { method: 'PUT', params: {} }});
                 factory.saveProductBasedAccounts = function(accounts, allowMissingAccounts, callback) {
                     $http({
                         method: "PATCH",
                         url: baseUrl + 'api/v1/accountingExportSettings/productBasedAccounts?allowMissingAccounts='+allowMissingAccounts,
                         cache: false,
                         params: {},                         
                         headers: {},
                         data: accounts 
                     }).then(callback);
                 };
                 factory.getProductBasedAccounts = function(settings,callback) {
                    $http({
                        method: "GET",
                        url: baseUrl + 'api/v1/accountingExportSettings/productBasedAccounts',
                        cache: false,
                    }).then(callback);
                };
                 return factory;
            }
        ]).factory('AccountingExportAvailableFields',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/accountingExportAvailableFields', {}, {});
            }
        ]).factory('AccountingExportWrapper',
        function() {

            function ExportWrapper() {
                this.data = [];
                this.lookup = {};
                this.firstRowId = "";
            }

            ExportWrapper.prototype.load = function(data) {
                var self = this;
                this.data = angular.isArray(data) ? data : [];
                this.lookup = toLookup(data);

                function toLookup(data) {
                    var lookup = {};
                    if (angular.isArray(data)) {
                        for (var i = 0; i < data.length; i++) {
                            var item = data[i];

                            if (i === 0) {
                                self.firstRowId = item.Id;
                            }

                            lookup[item.Id] = item;
                        }
                    }
                    return lookup;
                };
            };
            ExportWrapper.prototype.byId = function(id) {
                var result = this.lookup[id];
                if (!result) {
                    return this.data[0];
                }
                return result;
            };
            ExportWrapper.prototype.firstOrDefault = function() {
                if (this.data.length > 0) {
                    return this.data[0];
                } else {
                    return undefined;
                }
            };
            return ExportWrapper;

        }).factory('AccountingOperations',
        [
            '$http', function($http) {

                return {
                    createFile: function(reportId, format, successCallback, errorCallback) {
                        $http({
                            method: "POST",
                            url: "/api/v1/AccountingExports/" + reportId + "/files",
                            params: {},
                            data: { Format: format },
                            headers: {},
                            cache: false
                        }).then(function() {
                                if (successCallback) {
                                    successCallback();
                                }
                            },
                            function(error) {
                                if (errorCallback) {
                                    errorCallback(error);
                                }
                            });
                    },

                    exportPostings: function(kind, format, endDate, successCallback, errorCallback) {
                        var dto = {
                            Kind: kind,
                            ExportedDateRange: {
                                InclusiveEnd: endDate
                            },
                            Files: [
                                { Format: format }
                            ]
                        };

                        $http({
                            method: "POST",
                            url: "/api/v1/accountingexports/",
                            params: {},
                            data: dto,
                            headers: {},
                            cache: false
                        }).then(function() {
                                if (successCallback) {
                                    successCallback();
                                }
                            },
                            function(error) {
                                if (errorCallback) {
                                    errorCallback(error);
                                }
                            });
                    },

                    downloadFile: function(id, successCallback, errorCallback) {
                        $http({
                            method: "POST",
                            url: "/api/v1/AccountingExportFiles/" + id + "/downloadlink",
                            params: {},
                            data: {},
                            headers: {},
                            cache: false
                        }).then(function(downloadInfo) {
                                if (successCallback) {
                                    successCallback(downloadInfo);
                                }
                            },
                            function(error) {
                                if (errorCallback) {
                                    errorCallback(error);
                                }
                            });
                    }
                }
            }
        ]).factory('AccountLogout', ['$http', 'LoginDataCleanUp', function ($http, LoginDataCleanUp) {
            var service = {
                logout: function () {
                    let promise = $http({
                        method: "POST",
                        url: baseUrl + "api/v1/logout",
                        data: {},
                        cache: false
                    });

                    LoginDataCleanUp.clean();
                    return promise;
                }
            };

            return service;
        }
        ]).factory('LoginDataCleanUp', ['$http', '$rootScope', function ($http, $rootScope) {
            var service = {
                clean: function () {
                    if ($rootScope.getStoredAccessToken()) {
                        $rootScope.isLoggingOut = true;
                    }

                    delete $http.defaults.headers.common["X-SELECTED-LEGAL-ENTITY-ID"];

                    $rootScope.user = $rootScope.username = $rootScope.password = $rootScope.accessToken =
                        $rootScope.refreshToken = $rootScope.chosenEntity = $rootScope.permissions = null;

                    $rootScope.clearLocalStorage();

                    $http.defaults.headers.common["Authorization"] = null;
                }
            };

            return service;
        }
        ]).factory('AdminLogin',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/AdminLogin/:entityId', {}, {});
            }
        ]).factory('ExternalSubscriptionSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/settings/externalSubscriptions/:type',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('ExternalSubscription',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/externalSubscriptions/:id', {}, {});
            }
        ]).factory('ExternalSubscriptionRequestLog',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/externalSubscriptionRequestLog/:id', {}, {});
            }
        ]).factory('AvailableCountry',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/availableCountries',
                    {},
                    {
                        query: { method: 'GET', params: { locale: "de" }, isArray: true }
                    });
            }
        ]).factory('BillingSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/settings/billingSettings/', {}, { update: { method: 'PUT' } });
            }
        ]).factory('Component',
        [
            '$rootScope', '$resource', '$uibModal','babelFilter' , function ($rootScope, $resource, $modal, babelFilter) {
            const component = $resource(baseUrl + 'api/v1/components/:componentId',
                {},
                {
                    update: {method: 'PUT', params: {}},
                });
            component.openOverrideModalWindow = function (newComponentSubscription, overridingComponent, currency) {
                let productOverride = { Name: "", Description: "", PricePerUnit: "" };
                if(newComponentSubscription.ProductOverride)
                {
                    productOverride = JSON.parse(JSON.stringify(newComponentSubscription.ProductOverride))
                }
                const modalInstance = $modal.open({
                    templateUrl: 'partials/component-override-modal.html' + $rootScope.linkVersion,
                    windowClass: "fade in",
                    controller: ["$scope", function ($scope) {
                        $scope.component = productOverride;
                        $scope.currency = currency;
                        $scope.componentPlacehodlers =
                        {
                            Name: babelFilter(overridingComponent.Name),
                            PricePerUnit: overridingComponent.PricePerUnit ?
                                JSON.parse(JSON.stringify(overridingComponent.PricePerUnit)) : ""
                        }
                        $scope.save = function () {
                            if($scope.componentOverrideForm.pricePerUnit.$valid) {
                                newComponentSubscription.ProductOverride = $scope.component;
                                modalInstance.close();
                            }
                        };
                        $scope.cancel = function () {
                            modalInstance.close();
                        };
                        $scope.reset = function () {
                            $scope.component = { Name: "", Description: "", PricePerUnit: "" };
                            newComponentSubscription.ProductOverride = { Name: "", Description: "", PricePerUnit: "" }
                        }
                    }]
                });
            };
            return component;
        }
        ]).factory('ComponentByPlanGroup',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/planGroups/:planGroupId/components/:componentId', {}, {});
            }
        ]).factory('ComponentSubscription',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/componentSubscriptions/:componentSubscriptionId',
                    {},
                    {
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('ComponentUsage',
        [
            '$resource', function($resource) {
                return $resource(
                    baseUrl + 'api/v1/contracts/:contractId/usage/:usageId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
            }
        ]).factory('ComponentSubscriptionByContract',
        [
            '$resource', function($resource) {
                return $resource(
                    baseUrl + 'api/v1/contracts/:contractId/componentSubscriptions/:componentSubscriptionId',
                    {},
                    {
                        queryRecent: { method: 'GET', params: { dest: "recent", skip: 0, take: 100 } }
                    });
            }
        ]).factory('ComponentSubscriptionEnd',
        [
            '$resource', function($resource) {
                return $resource(baseUrl +
                    'api/v1/contracts/:contractId/componentSubscriptions/:componentSubscriptionId/end',
                    {},
                    {});
            }
        ]).factory('DiscountSubscription',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/discountSubscriptions/:discountSubscriptionId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('DiscountSubscriptionEnd',
        [
            '$resource', function($resource) {
                return $resource(baseUrl +
                    'api/v1/contracts/:contractId/discountSubscriptions/:discountSubscriptionId/end',
                    {},
                    {});
            }
        ]).factory('Contract',
        [
            '$resource', '$http','babelFilter', 'DatepickerUtils', 'PUtill', 'TimeGranularity', function($resource, $http, babelFilter,  DatepickerUtils, PUtill, TimeGranularity) {
                let contract = $resource(baseUrl + 'api/v1/contracts/:contractId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: {} },
                        patchUpdate: { method: 'PATCH', params: {} }
                    });
                
                    let getContractActivePhaseStartByDate = function (contractObj, momentOfDate) {
                        let id = 0;
                        let activePhaseStart = null;
                        do {
                            if (!contractObj.Phases[id].InheritStartDate) {
                                let phaseStart = new Date(contractObj.Phases[id].StartDate);
                                var diff = moment(phaseStart).diff(momentOfDate, 'days');
                                if (diff <= 0)
                                    activePhaseStart = phaseStart;
                            }
                            id++;
                        } while (diff <= 0 && id < contractObj.Phases.length);

                        if (activePhaseStart == null)
                            throw new Error("Date before contract start selected!");
                        
                        return activePhaseStart;
                    };
                    
                    contract.getDateToPhaseStartTimeAdjusted = function (contractObj, cetMidnightInBrowserTimezone) {
                        
                        let phaseStart = getContractActivePhaseStartByDate(contractObj, moment(cetMidnightInBrowserTimezone));
                        let result = new Date(cetMidnightInBrowserTimezone);
                        let isCurrentTzAwareOfDst = PUtill.isCurrentTzAwareOfDst();
                        
                        let initialOffsetMinutes = moment(phaseStart).tz(PUtill.BerlinTzName).utcOffset();
                        let chosenOffsetMinutes = moment(cetMidnightInBrowserTimezone).tz(PUtill.BerlinTzName).utcOffset();
                        let offsetToAdd = isCurrentTzAwareOfDst ? 0 : initialOffsetMinutes - chosenOffsetMinutes;

                        let isDayBillingPrecision = contractObj.TimeGranularity === TimeGranularity.Day;
                        if (!isDayBillingPrecision)
                            result.setHours(phaseStart.getHours(), phaseStart.getMinutes() + offsetToAdd, phaseStart.getSeconds(), phaseStart.getMilliseconds());

                        DatepickerUtils.markAsAlreadyInBrowserTimezone(result);
                        if (cetMidnightInBrowserTimezone > result)
                            result.setDate(result.getDate() + 1);

                        if (!isCurrentTzAwareOfDst && !isDayBillingPrecision) {
                            let resultOffsetMinutes = moment(result).tz(PUtill.BerlinTzName).utcOffset();
                            let resultOffset = chosenOffsetMinutes - resultOffsetMinutes;
                            if (resultOffset !== 0)
                                result.setMinutes(result.getMinutes() + resultOffset);
                        }
                        
                        return result;
                    };
                    
                    return contract;
            }
        ]).factory('ContractChange',
        [
            '$resource', '$http', function($resource, $http) {
                let factory = $resource(baseUrl + 'api/v1/contractchanges/',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
                
                factory.getContractChangeById = function (id, params){
                    return $http({
                        method: "GET",
                        url: baseUrl + 'api/v1/contractchanges/' + id,
                        params: params,
                        data: {}
                    });
                };
                
                return factory;
            }
        ]).factory('ContractUpgrade',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/upgrade', {}, {});
            }
        ]).factory('ContractCancellationPreview',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/cancellationPreview', {}, {});
            }
        ]).factory('ContractEndPreview',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/endPreview', {}, {});
            }
        ]).factory('ContractCancellationPreview',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/cancellationPreview', {}, {});
            }
        ]).factory('ContractTimeDetails',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/times', {}, {});
            }
        ]).factory('ContractEndDate',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/endDate', {}, {});
            }
        ]).factory('Coupon',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/coupons/:couponId',
                    {},
                    {
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('CouponByPlanGroup',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/planGroups/:planGroupId/coupons/:couponId', {}, {});
            }
        ]).factory('CouponCodes',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/coupons/codes',
                    {},
                    {
                    });
            }
        ]).factory('Coupons',
    [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/coupons/');
        }
        ]).factory('CouponSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/settings/couponSettings/', {}, {});
            }
        ]).factory('DebitorAccountGenerator',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/DebitorAccountGenerator',
                    {},
                    {
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('Discount',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/discounts/:discountId',
                    {},
                    {
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('DiscountByPlanGroup',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/planGroups/:planGroupId/discounts/:discountId', {}, {});
            }
        ]).factory('DiscountSubscriptionByContract',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/discountSubscriptions/:discountSubscriptionId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
            }
        ]).factory('InvoiceBuilderPreview',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/invoiceBuilderPreview', {}, {});
            }
        ]).factory('InvoiceBuilder',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/invoiceBuilder', {}, {});
            }
        ]).factory('ContractSelfServiceToken',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/selfServiceToken', {}, {});
            }
        ]).factory('PlanAndBillingSettings',
        [
            '$resource', function($resource) {
            return $resource(baseUrl + 'api/v1/planAndBillingSettings', {}, {});
        }
        ]).factory('ContractUnbilledMeteredLineItems',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/unbilledMeteredLineItems', {}, {});
            }
        ]).factory('ContractByCustomer',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/customers/:customerId/contracts/:contractId', {}, {});
            }
        ]).factory('MassWriteOffs', [ '$resource', function($resource) {
            return $resource(baseUrl + 'api/v1/massWriteOff', { }, { query: { method: 'GET', isArray: true } });
        }]).factory('BulkUpdates', ['$resource', function ($resource) {
            return $resource(baseUrl + 'api/v1/bulkoperation', {}, { query: { method: 'GET', isArray: true } });
        }]).factory('ContractInterimBill',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/bill', {}, {});
            }
        ]).factory('Customer',
        [
            '$resource', function($resource) {
                let service = $resource(baseUrl + 'api/v1/customers/:customerId',
                    { },
                    {
                        query: { method: 'GET', params: { skip: 0, take: 500 }, isArray: true },
                        update: { method: 'PUT', params: { } },
                        patchUpdate: { method: 'PATCH', params: { } },
                    })

                service.canShowBuyerReference = function(isZugFerdActive, invoiceAttachmentDisplayFormat, showEInvoiceFields) {
                    return (isZugFerdActive && invoiceAttachmentDisplayFormat &&
                        invoiceAttachmentDisplayFormat.toLowerCase().startsWith('zugferd')) ||
                        showEInvoiceFields;
                };

                return service;
            }
        ]).factory('CustomerExternal',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/externalCustomers/:externalCustomerId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 500 }, isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('CustomFieldSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/customFieldSettings',
                    {},
                    {
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('DeferredIncomeReport',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/DeferredIncomeReport',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 500 }, isArray: true },
                    });
            }
        ]).factory('Dunning',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/dunnings/:dunningId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('DunningDownload',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/dunnings/:dunningId/downloadLink',
                    {},
                    {});
            }
        ]).factory('DunningResend',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/dunnings/:dunningId/resendDocument', {}, {});
            }
        ]).factory('DunningBearerMedium',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/dunnings/bearerMedium', { dunningId: ':dunningId' }, {});
            }
        ]).factory('DunningDownloadByFilter',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/dunnings/downloadLink',
                    {},
                    {
                    });
            }
        ]).factory('DunningsCount',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/dunnings/count',
                    { alldunnings: true },
                    {
                    });
            }
        ]).factory('DunningSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/settings/dunningSettings/', {}, { update: { method: 'PUT' } });
            }
        ]).factory('Invoice',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/invoices/:invoiceId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
            }
        ]).factory('InvoiceCorrection',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/invoices/:invoiceId/correction', {}, {});
            }
        ]).factory('InvoiceDownload',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/invoices/:invoiceId/downloadLink', {}, {});
            }
        ]).factory('InvoiceResend',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/invoices/:invoiceId/resendDocument', {}, {});
            }
        ]).factory('InvoiceBearerMedium',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/invoices/:invoiceId/bearerMedium', {}, {});
            }
        ]).factory('InvoiceDownloadByFilter',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/invoices/downloadlink',
                    {},
                    {
                    });
            }
        ]).factory('EmailNotificationsTemplate',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/emailNotificationsTemplates/:templateId',
                    {},
                    {
                        update: { method: 'PUT', params: {} }
                    });
            }
       ]).factory('EmailNotificationsTemplatesByEventCategory',
            [
                '$resource', function ($resource) {
                    return $resource(baseUrl + 'api/v1/emailNotificationsTemplates?category=:category');
            }
        ]).factory('EmailNotificationsEvents',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/emailNotificationsEvents',
                    {},
                    {
                        update: { method: 'PUT', params: {} }
                    });
            }
        ])
    .factory('DocumentEmailTemplate',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/documentEmailTemplates/:emailType',
                    {},
                    {
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('EmailTemplatePlaceholder',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/EmailTemplatePlaceholders/', {}, {});
            }
        ]).factory('DocumentTemplate',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/documentTemplates/:documentType/:id',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('PaymentEscalationReset',
        [
            '$http', function($http) {
                return {
                    save: function (contractId, data) {
                        return $http({
                            method: 'POST',
                            url: baseUrl + 'api/v1/contracts/' + contractId + '/resetPaymentEscalation',
                            data: data
                        });
                    }
                };
            }
        ]).factory('EscalationCheckSuspend',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/suspendEscalationCheck', {}, {});
            }
        ]).factory('Attachment',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/attachment/:attachmentId',
                    {
                        attachmentId: '@Id'

                    },
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('DownloadService',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/documents/:id/downloadlink',
                    { searchByName: '@searchByName' },
                    {}
                );
            }
        ]).factory('ReportDownloadService',
        [
            '$http', function($http) {
                return {
                    downloadReport: function(id, parameters, successCallback, errorCallback) {
                        $http({
                            method: "POST",
                            url: "/api/v1/reports/" + id + "/downloadLink",
                            params: {},
                            data: parameters,
                            headers: {},
                            cache: false
                        }).then(function(downloadInfo) {
                                if (successCallback) {
                                    successCallback(downloadInfo);
                                }
                            },
                            function(error) {
                                if (errorCallback) {
                                    errorCallback(error);
                                }
                            });
                    }
                }
            }
        ]).factory('PdfTemplateDownload',
            [
                '$resource', function ($resource) {
                    return $resource(baseUrl + 'api/v1/salesEntities/:salesEntityId/pdfSettings/templates/:templateName/downloadLink',
                        { salesEntityId: '@id'},
                        {
                        });
                }
        ]).factory('InvoiceDraft',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/invoiceDrafts/:invoiceDraftId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('InvoiceDraftCorrection',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/invoiceDrafts/:invoiceDraftId/correction', {}, {});
            }
        ]).factory('Plan',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/plans/:planId',
                    { planId: '@Id' },
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('PlanByPlanGroup',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/planGroups/:planGroupId/plans/:planId', {}, {});
            }
        ]).factory('PlanOrder',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/planOrders/',
                    {},
                    {
                        query: { method: 'GET', params: {} },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('PlanVariant',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/planVariants/:planVariantId',
                    { planVariantId: '@Id' },
                    {
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('PlanVariantByPlan',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/plans/:planId/planVariants/:planVariantId', {}, {});
            }
        ]).factory('PlanGroup',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/planGroups/:planGroupId',
                    {},
                    {
                        query: { method: 'GET', isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('PriceList',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/priceLists/:priceListId',
                    {},
                    { 
                        query: { method: 'GET', isArray: true, params: {} },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('ProductPrices',
        [
            '$resource', function ($resource) {
                return $resource(baseUrl + 'api/v1/priceLists/prices',
                    {},
                    {
                        query: { method: 'GET', isArray: true },
                    });
            }
        ]).factory('PriceListItems',
        [
            '$resource', function ($resource) {
                return $resource(baseUrl + 'api/v1/priceLists/modifypricelistitems',
                    {},
                    {
                        update: { method: 'PUT', params: {} },
                    });
            }
        ]).factory('PriceLists',
        [
            '$resource', function ($resource) {
                return $resource(baseUrl + 'api/v1/priceLists/',
                    {},
                    {
                        query: {
                            method: 'GET', 
                            isArray: true
                            },
                        update: {method: 'PUT', params: {}}
                    });
            }
        ]).factory('SelfService',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/selfService/', {}, {});
            }
        ]).factory('LegalSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/settings/legalSettings/', {}, { update: { method: 'PUT' } });
            }
        ]).factory('SelfServiceSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/selfServiceSettings/', {}, {});
            }
        ]).factory('UserSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/settings/userSettings', {}, { update: { method: 'PUT' } });
            }
        ]).factory('SecuritySettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/settings/securitySettings', {}, { update: { method: 'PUT' } });
            }
        ]).factory('CompanySettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/settings/companySettings', {}, { update: { method: 'PUT' } });
            }
        ]).factory('BackupSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/settings/backupSettings', {}, { update: { method: 'PUT' } });
            }
        ]).factory('RtlFastStatsReportSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/settings/RtlFastStatsReportSettings',
                    {},
                    { update: { method: 'PUT' } });
            }
        ]).factory('Order',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/orders/:orderId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                    });
            }
        ]).factory('EInvoicingLogs',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/EInvoicingLogs',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 20 }, isArray: true }
                    });
            }
        ]).factory('OAuthClient',
        [
            '$resource', '$http', function($resource, $http) {
                let service = $resource(baseUrl + 'api/v1/settings/oauthClients/:clientId', {}, {
                    update: { method: 'PUT', params: {} }
                });

                service.deleteSecret = function (id){
                        return $http({
                            method: "DELETE",
                            url: baseUrl + 'api/v1/settings/oauthClients/secrets/' + id,
                        });
                }

                return service;
            }
        ]).factory('OAuthClientSecret',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/settings/oauthClients/:clientId/secrets', {}, {
                    create: { method: 'POST', params: {} }
                })
            }
        ]).factory('OAuthGrantClient',
        [
            '$resource', function($resource) {
            var oauthGrantClient = $resource(baseUrl + 'api/v1/settings/oauthGrants', 
                {}, 
                {
                    query: { method: 'GET', params: { }, isArray: true }
                });

            return oauthGrantClient;
        }
        ]).factory('Signup',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/signup/', {}, {});
            }
        ]).factory('TaxPolicy',
        [
            '$resource', function($resource) {
                var taxPolicy = $resource(baseUrl + 'api/v1/taxPolicies/:taxPolicyId',
                    {},
                    {
                        update: { method: 'PUT', params: {} }
                    });
                taxPolicy.getDefaultTaxPolicyId = function(taxPolicies) {
                    if (taxPolicies) {
                        if (taxPolicies.length === 1)
                            return taxPolicies[0].Id;
                    }
                    return null;
                };

                return taxPolicy;
            }
        ]).factory('TaxDefinition',
        [
            '$resource', function ($resource) {
                return $resource(baseUrl + 'api/v1/taxDefinitions/:id',
                    {},
                    {
                        query: { method: 'GET', isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('PasswordSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/account/password',
                    {},
                    {
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('BankAccount',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/bankAccounts/:bankAccountId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('AccountSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/account',
                    {},
                    {
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('GeneralEmailSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/generaldocumentssettings',
                    {},
                    {
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('NumberSequence',
        [
            '$resource', function($resource) {
                var service = $resource(baseUrl + 'api/v1/sequences/:sequenceId',
                    { },
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: { } }
                    });

                service.getDocumentCounterSequences = function() {
                    let sequencePromise = service.query().$promise.then(function (data) {
                        return data.filter(function (sequence) {
                            return sequence.SequenceType === 'Document';
                        });
                    });

                    return Promise.resolve(sequencePromise);
                };

                return service;
            }
        ]).factory('PaymentProviderSettings',
        [
            '$resource', 'gettext', 'gettextCatalog', 'PaymentMethodNames',
            function($resource, gettext, gettextCatalog, PaymentMethodNames) {
                const blackLabelRole = 'BlackLabel';
                const noneRoleOrMethod = 'None';

                let service = $resource(baseUrl + 'api/v1/paymentProviderSettings/:paymentProvider/:paymentProviderExternalId',
                    { },
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: { } }
                    });

                let paymentMethodNamesEN = PaymentMethodNames.get();
                service.names = function () {
                    let promise = service.query().$promise.then(function (data) {
                        const validProviders = data.filter(function (provider) {
                            return provider.Valid && (provider.IsBlackLabelProvider ||
                                provider.IsCreditCardProvider ||
                                provider.IsDebitProvider ||
                                provider.IsAutogiroProvider ||
                                provider.IsAvtalegiroProvider ||
                                provider.IsBetalingsserviceProvider ||
                                provider.IsiDEALProvider ||
                                provider.IsApplePayProvider ||
                                provider.IsVippsMobilePayProvider||
                                provider.IsPayPalProvider ||
                                provider.IsAfterPayProvider ||
                                provider.IsTWINTProvider
                            );
                        });

                        let resultList = [];

                        angular.forEach(validProviders, function (providerAndRole) {
                            let provider = providerAndRole.PaymentProvider;

                            if (providerAndRole.IsCreditCardProvider)
                                resultList.push(service.toKeyNamePair('CreditCard', provider));
                            if (providerAndRole.IsBlackLabelProvider)
                                resultList.push(service.toKeyNamePair(blackLabelRole, provider));
                            if (providerAndRole.IsDebitProvider)
                                resultList.push(service.toKeyNamePair('Debit', provider));
                            if (providerAndRole.IsOnAccountProvider)
                                resultList.push(service.toKeyNamePair('OnAccount', provider));
                            if (providerAndRole.IsAutogiroProvider)
                                resultList.push(service.toKeyNamePair('Autogiro', provider));
                            if (providerAndRole.IsAvtalegiroProvider)
                                resultList.push(service.toKeyNamePair('Avtalegiro', provider));
                            if (providerAndRole.IsBetalingsserviceProvider)
                                resultList.push(service.toKeyNamePair('Betalingsservice', provider));
                            if(providerAndRole.IsiDEALProvider)
                                resultList.push(service.toKeyNamePair('iDEAL', provider))
                            if(providerAndRole.IsApplePayProvider)
                                resultList.push(service.toKeyNamePair('ApplePay', provider))
                            if(providerAndRole.IsVippsMobilePayProvider)
                                resultList.push(service.toKeyNamePair('VippsMobilePay', provider))
                            if(providerAndRole.IsPayPalProvider)
                                resultList.push(service.toKeyNamePair('PayPal', provider))
                            if(providerAndRole.IsAfterPayProvider)
                                resultList.push(service.toKeyNamePair('AfterPay', provider))
                            if(providerAndRole.IsTWINTProvider)
                                resultList.push(service.toKeyNamePair('TWINT', provider))
                        });

                        resultList.push(service.toKeyNamePair(noneRoleOrMethod, noneRoleOrMethod));
                        return resultList;
                    });

                    return Promise.resolve(promise);
                }

                service.toKeyNamePair = function(role, provider) {
                    function textOf(msg) {
                        return gettextCatalog.getString(gettext(msg));
                    }

                    let key = role + ':' + provider;
                    let value = textOf(role) + ' [ ' + textOf(provider) + ' ]';

                    if (role === blackLabelRole)
                        value = textOf(paymentMethodNamesEN[key]) || paymentMethodNamesEN[key] || value;
                    else if (role === noneRoleOrMethod)
                        value = textOf(paymentMethodNamesEN[key]) || value;

                    return { key: key, name: value };
                }

                return service;
            }
        ])
    .factory('PaymentProviderHandlingFeesSettings',
        ['$http', function($http) {
                var service = {
                    getHandlingFees: function (paymentProvider, successfulCallback, paymentProviderExternalId) {
                        $http({
                                method: "GET",
                                url: baseUrl + 'api/v1/paymentProviderSettings/handlingFees/' + paymentProvider + '/' + paymentProviderExternalId,
                                cache: false
                        })
                            .then(successfulCallback);
                    },
                    saveHandlingFees: function (paymentProvider, handlingFees, successfulCallback, paymentProviderExternalId) {
                        $http({
                                method: "PUT",
                                url: baseUrl + 'api/v1/paymentProviderSettings/handlingFees/' + paymentProvider + '/' + paymentProviderExternalId,
                                cache: false,
                                data: handlingFees
                            })
                            .then(successfulCallback);
                    }
                };

                return service;
            }])
    .factory('ThirdPartyIntegrationSettings',
        [
            '$resource', function ($resource) {
                return $resource(baseUrl + 'api/v1/thirdPartyIntegrationSettings/:thirdPartyIntegration',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ])
    .factory('IdentityProviderSettings',
        [
            '$resource', function ($resource) {
            return $resource(baseUrl + 'api/v1/thirdPartyIntegrationSettings/identityProviderSettings',
                {},
                {
                    get: { method: 'GET' },
                });
        }
        ])
    .factory('SEPADDSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/settings/SEPADDSettings', {}, { update: { method: 'PUT' } });
            }
        ]).factory('PaymentMethod',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/paymentMethods/',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
            }
    ])
    .factory('PrepaidCardProfile',
    [
        '$resource', function ($resource) {
            return $resource(baseUrl + 'api/v1/PrepaidCardsProfile/:id',
                {},
                {
                    query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                    update: { method: 'PUT', params: {} }
                });
        }
    ])
    .factory('Webhook',
        [
            '$resource', function ($resource) {
                return $resource(baseUrl + 'api/v1/webhooks/:webhookId',
                    {},
                    {
                        update: { method: 'PUT', params: {} },
                        unsuspend: { method: 'POST', url: baseUrl + 'api/v1/webhooks/:webhookId/unsuspend' }
                    });
            }
        ])
    .factory('WebhookTest',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/webhooks/test', { }, { test: { method: 'POST' } });
            }
        ]).factory('SimulationParams',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/Simulation/', {}, { save: { method: 'POST', isArray: true } });
            }
        ]).factory('FakeTimeSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/Simulation/fakeTime', {}, { save: { method: 'POST' } });
            }
        ]).factory('FakeTimeSettings',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/Simulation/fakeTime', {}, { save: { method: 'POST' } });
            }
        ]).factory('Fonts',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/Fonts', {}, {});
            }
        ]).factory('PaymentTransaction',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/paymentTransactions/:paymentTransactionId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
            }
        ]).factory('PaymentRefund',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/paymentRefunds/:paymentRefundId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
            }
        ]).factory('PSPWarning',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/paymentProviderWarnings/',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
            }
        ]).factory('PaymentEscalationProcess',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/paymentEscalationProcess/:paymentEscalationProcessId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('Subscription',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/subscriptions',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 500 }, isArray: true }
                    });
            }
        ]).factory('AccountingExport', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/AccountingExports/:id', {}, {
            query: { method: 'GET', params: {}, isArray: true }
        });
		}]).factory('AccountingExportFile', ['$resource', function ($resource) {
			return $resource(baseUrl + 'api/v1/AccountingExportFiles/:id', {}, {
				query: { method: 'GET', params: {}, isArray: true }
			});}
		]).factory('AccountingExportV1Postings', ['$resource', function ($resource) {
			return $resource(baseUrl + 'api/v1/AccountingExportV1Postings/', {}, {
				query: { method: 'GET', params: {}, isArray: true }
			});}
        ]).factory('PostingGroup', ['$resource', function ($resource) {
			return $resource(baseUrl + 'api/v1/postingGroups/:postingGroupId', {}, {
                query: { method: 'GET', isArray: true }
        }); }
    ])
    .factory('PostingsExtended', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/postingGroups/postings/', {}, {
                query: { method: 'GET', isArray: true }
            });
        }
    ])
    .factory('AccountingStatus', ['$resource', function ($resource) {
            return $resource(baseUrl + 'api/v1/AccountingStatus', {}, {
        });
    }]).factory('Report',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/reports/',
                    {},
                    {
                        query: {
                            method: 'GET',
                            params: { skip: 0, take: 100 },
                            headers: { 'X-ACTIVITY': 'SKIP' },
                            isArray: true
                        }
                    });
            }
        ]).factory('PaymentsExport',
        [
            '$resource', function ($resource) {
                return $resource(baseUrl + 'api/v1/PaymentsExports/',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
            }]).factory('SubscriptionCounts',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/subscriptions/counts', {}, {});
            }
        ]).factory('SubscriptionReport',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/subscriptions/report', {}, {});
            }
        ]).factory('PaymentTransactionReport',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/PaymentTransactions/report', {}, {});
            }
        ]).factory('LedgerEntryByCustomer',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/customers/:customerId/ledgerEntries/:ledgerEntryId', {}, {});
            }
        ]).factory('LedgerEntryByContract',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/ledgerEntries/:ledgerEntryId',
                {},
                {
                    query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                });
            }
        ]).factory('CountryList',
        [
            '$http', function($http) {
                var service = {
                    countries: null,
                    getCountries: function(isWhiteList = false) {
                        let promise = $http({ "method": "GET", url: baseUrl + "api/v1/CountryList?isWhiteList=" + isWhiteList, cache: false });
                        promise.then(function(result) {
                            service.countries = result.data;
                        });
                        return promise;
                    }
                };
                
                return service;
            }
        ]).factory('CountryStates',
                [
                    '$http', function ($http) {
                        var service = {
                            states: null,
                            getStates: function (country) {
                                var promise = $http({ "method": "GET", url: baseUrl + "api/v1/CountryStates/" + country, cache: false });
                                promise.then(function (result) {
                                    service.states = result.data;
                                });
                                return promise;
                            }
                        };
                    return service;
                }
        ]).factory('EntityUseCodes',
        [
            '$http', '$q', function ($http, $q) {
                var service = {
                    entityUseCodes: null,
                    getCodes: function () {
                        var promise = $http({"method": "GET", url: baseUrl + "api/v1/EntityUseCodeList/", cache: false});
                        promise.then(function (result) {
                            theService.entityUseCodes = result.data;
                        });
                        return promise;
                     }
                 };
                 return service;
            }
        ]).factory('LocaleList',
        [
            '$http', '$q', function($http, $q) {
                var service = {
                    locales: null,
                    getLocales: function() {
                        var theService = this;
                        if (theService.locales) {
                            var deferred = $q.defer();
                            deferred.resolve({ data: theService.locales });
                            return deferred.promise;
                        }
                        var promise = $http({ "method": "GET", url: baseUrl + "api/v1/LocaleList", cache: true });
                        promise.then(function(result) {
                            if (!theService.locales)
                                theService.locales = result.data;
                        });
                        return promise;
                    }
                };
                return service;
            }
        ]).factory('PlanGroupStats',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/planGroupStats/',
                    {},
                    {
                        query: { method: 'GET', params: {}, isArray: false }
                    });
            }
        ]).factory('Reconciliation',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/reconciliation',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 500 }, isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('ReconciliationAssign',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/reconciliationAssign/:transactionId', {}, {});
            }
        ]).factory('ReconciliationAssignSearch',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/reconciliationAssign/',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 500 }, isArray: true }
                    });
            }
        ]).
    factory('ReconciliationManualMode',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/reconciliationManualMode/',
                    {},
                    { query: { method: 'GET', isArray: false }, update: { method: 'PUT', params: {}, isArray: true } });
            }
        ]).
    factory('User',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/users/:id',
                    {},
                    {
                        query: { method: 'GET', isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('SharedParameters',
        function() {
            var data = [];

            return {
                getValue: function(key) {
                    return data[key];
                },
                setValue: function(key, value) {
                    data[key] = value;
                }
            };
        }).factory('ReconciliationImport',
        [
            '$resource', '$http', function($resource, $http) {
                let factory =  $resource(baseUrl + 'api/v1/reconciliationImport/',
                    {},
                    {  query: { method: 'GET', params: { skip: 0, take: 10 }, isArray: true } });

                factory.getLastAutoDownloadTimestamp = function(settings, callback) {
                    $http({
                        method: "GET",
                        url: baseUrl + 'api/v1/reconciliationImport/lastAutoDownloadTimestamp',
                        cache: false,
                    }).then(callback);
                };
                
                return factory;
            }            
        ]).factory('ContractRefund',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/refund', {}, {});
            }
        ]).factory('UserNotifications',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/userNotifications/',
                    {},
                    { query: { method: 'GET', isArray: false } });
            }
        ]).factory('ChargebackFee',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/chargebackfees',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        update: { method: 'PUT', params: {} }
                    });
            }
        ]).factory('ChargebackFeeDownloadByFilter',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/chargebackfees/downloadlink', {}, {});
            }
        ]).factory('UpgradeFees',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/updatehandlingfees', {}, { save: { method: 'POST' } });
            }
        ]).factory('Email',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/emails',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
            }
        ]).factory('System',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/system', {}, {});
            }
        ]).factory('ContractChangePaymentMethod',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/changepaymentmethod', {}, {});
            }
        ]).factory('Features',
        [
            '$http', '$q', function ($http, $q) {
                var result = {};
                result.features = {};
                var loaded = false;

                result.loadingAsPromise = function () {
                    result.loading = $http({
                        method: "GET",
                        url: baseUrl + 'api/v1/features',
                        data: {}
                    });

                    return result.loading;
                }

                result.reload = function () {
                    // clear features
                    Object.keys(result.features).forEach(function (key) { delete result.features[key]; });

                    if (!$http.defaults.headers.common["Authorization"]) {
                        loaded = false;
                        return $q.when(result.features);
                    }

                    return result.loadingAsPromise().then(
                        function (response) {
                            var data = response.data;

                            for (var i = 0; i < data.length; i++) {
                                result.features[data[i]] = true;
                            }

                            if(result.features.apple_iap || result.features.amazon_iap || result.features.GoogleIap || result.features.RokuPay) {
                                result.features.AnyIap = true;
                            }

                            loaded = true;

                            return result.features;
                        },
                        function (error) {
                            //error code
                        }
                    );
                };

                result.load = function () {
                    if (!loaded) {
                        return result.reload();
                    }

                    return $q.when(result.features);
                };

                result.reload();

                return result;
            }
        ]).factory('Permissions',
        [
            '$http', '$rootScope', '$q', function ($http, $rootScope, $q) {
                var result = {};

                result.loadingAsPromise = function () {
                    return $http({
                        method: "GET",
                        url: baseUrl + 'api/v1/permissions',
                        data: {}
                    })
                }

                result.savePermission = function (permission) {
                    $rootScope.permissions = permission;

                    if ($rootScope.permissions)
                        localStorage.setItem('permissions', angular.toJson(permission));
                }

                result.reload = function () {
                    if (!$http.defaults.headers.common["Authorization"]) {
                        return $q.when({});
                    }

                    return result.loadingAsPromise().then(
                        function (response) {
                            result.savePermission(response.data);
                        }
                    );
                };

                return result;
            }
        ]).factory('PaymentMethodNames',
        function() {
            return {
                get: function() {
                    return {
                        "PayPal": "PayPal",
                        "CreditCard:PayOne": "Credit Card",
                        "Debit:PayOne": "Direct Debit",
                        "CreditCard:FakeProvider": "Credit Card",
                        "OnAccount:PayOne": "On Account",
                        "Debit:FakeProvider": "Direct Debit",
                        "FakeProvider": "Fake Provider",
                        "None:None": "Without Payment Data",
                        "BlackLabel:InvoicePayment": "On Account",
                        "Debit:SepaXml": "Direct Debit",
                        "Debit:GoCardless": "Direct Debit",
                        "Betalingsservice:PayExInvoiceService":"Betalingsservice",
                        "Autogiro:PayExInvoiceService": "Autogiro",
                        "Avtalegiro:PayExInvoiceService": "Avtalegiro",
                        "Debit:Mollie": "Direct Debit",
                        "Debit:Reepay": "Direct Debit",
                        "CreditCard:Mollie": "Credit Card",
                        "iDEAL:Mollie": "iDEAL",
                        "Betalingsservice:FarPay":"Betalingsservice",
                        "AmazonPay": "AmazonPay",
                        "CreditCard:Reepay": "Credit Card",
                        "ApplePay:Reepay": "ApplePay",
                        "BlackLabel:SwanOnAccount": "On Account (virtual IBANs)",
                        "CreditCard:ThirdPartyIntegration": "Credit Card",
                        "Debit:ThirdPartyIntegration": "Direct Debit",
                        "VippsMobilePay:Reepay": "VippsMobilePay",
                        "PayPal:Reepay": "PayPal",
                        "TWINT:Reepay": "TWINT",
                        "AfterPay:Riverty": "AfterPay",
                        "CreditCard:Riverty": "Credit Card",
                        "Debit:UnzerV2": "Direct Debit",
                    };
                }
            };
        }).factory("InvoiceAttachmentDisplayFormats",
            ['gettext', 'gettextCatalog', 'PdfDocumentFormat', function (gettext, gettextCatalog, PdfDocumentFormat) {
                return {
                    getFormats: function() {
                        return [{
                                type: PdfDocumentFormat.NoEInvoiceAttachment,
                                displayName: gettextCatalog.getString(gettext("no e-invoice attachment"))
                            },
                            {
                                type: PdfDocumentFormat.ZugFerd2Comfort,
                                displayName: "ZUGFeRD v2.3.0 - Comfort Profile"
                            },
                            {
                                type: PdfDocumentFormat.ZugFerd2XRechnung,
                                displayName: "ZUGFeRD v2.3.0 - XRechnung Profile"
                            }];
                    }
                };
            }
        ]).factory('OrderPaymentTransactions',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/orders/:orderId/PaymentTransactions',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
            }
        ]).factory('GeneralPaymentSettings',
        [
            '$resource','$http', function($resource, $http) {
                let factory = $resource(baseUrl + 'api/v1/generalPaymentSettings/', {}, { update: { method: 'PUT' } });
                factory.queryPlaceHolders = function(callback) {
                    $http({
                        method: "GET",
                        url: baseUrl + 'api/v1/generalPaymentSettings/reflineplaceholders',
                        data: {}
                    }).then(callback);
                };
                factory.queryPlaceHolderDescription = function(callback) {
                    $http({
                        method: "GET",
                        url: baseUrl + 'api/v1/generalPaymentSettings/placeholderdescription',
                        data: {}
                    }).then(callback);
                };
                return factory;
            }

        ]).factory('AccountDemoData',
        [
           '$http', function($http) {
            return function(callback) {
                $http({
                    method: "POST",
                    url: "api/v1/demodata",
                }).then(callback)
            };
        }
        ]).factory('AccountRelatedData',
        [
            '$http', function($http) {
            return function (callback) {

                $http({
                    method: "DELETE",
                    url: "api/v1/relateddata",
                }).then(callback)
            };
        }
        ]).factory('AccountProductData', [ '$http', function($http) {
            return function (callback) {
                $http({
                    method: "DELETE",
                    url: "api/v1/productdata",
                }).then(callback)
            };
        }
        ]).factory('Heartbeat', ['$http', function ($http) {
            return function (successCallback, errorCallback) {
                    $http({
                        method: "GET",
                        url: "api/v1/heartbeat",
                        headers: { "X-ACTIVITY": "SKIP" }
                    }).then(successCallback, errorCallback);
                };
            }
        ]).factory('SessionActivityState',
            [
                function () {
                    let service = {};

                    const settings = {
                        // All the below settings are in seconds.
                        cycleInterval: 1,
                        activityConsolidationPeriod: 3,
                        pollingPeriod: 60, // 1 Minute
                        inactivityPeriodThreshold: (3 * 60 * 60), // 3 Hours
                        autoLogoutWarningBefore: (5 * 60), // 5 minutes
                    };

                    // State variables to keep track of things.
                    let lastRecordedAt = lastHeartbeatAt = currentCycleTimeUTC = moment().utc();
                    let warningAlreadyRaised = false;
                    
                    // Ensures user activity updates are not recorded too frequently, avoiding unnecessary processing.
                    service.IsSafetyDelayElapsed = function () {
                        let periodSinceLastActivity = currentCycleTimeUTC.diff(lastRecordedAt, 'seconds');
                        return (periodSinceLastActivity >= settings.pollingPeriod);
                    };

                    // Ensures the heartbeat API is not called too often, reducing backend load.
                    service.IsHeartbeatIntervalElapsed = function () {
                        let periodSinceLastHeartbeat = currentCycleTimeUTC.diff(lastHeartbeatAt, 'seconds');
                        return (periodSinceLastHeartbeat >= settings.pollingPeriod);
                    };

                    // Consolidating the recordable activities into one. Otherwise, it may flood the server with very frequent activity updates.
                    // Results in a single activity update for requests happening within the period defined as activityConsolidationPeriod.
                    service.IsActivityConsolidationPeriodElapsed = function () {
                        let difference = currentCycleTimeUTC.diff(lastRecordedAt, 'seconds');
           
                        return (difference > settings.activityConsolidationPeriod);
                    };

                    service.IsTimeToRaiseWarning = function () {
                        let periodSinceLastActivity = currentCycleTimeUTC.diff(lastRecordedAt, 'seconds');
                        return ((periodSinceLastActivity >= (settings.inactivityPeriodThreshold - settings.autoLogoutWarningBefore))
                            && warningAlreadyRaised === false);
                    }

                    service.RefreshCurrentCycleTime = function () {
                        currentCycleTimeUTC = moment().utc();
                    };

                    service.RefreshLastRecordedTime = function () {
                        lastRecordedAt = moment().utc();
                        warningAlreadyRaised = false;
                    };

                    service.RefreshLastHeartbeatTime = function () {
                        lastHeartbeatAt = currentCycleTimeUTC;
                    };

                    service.RecordRemoteActivity = function (lastRemoteActivityUtcString) {
                        let lastActivitySomewhereElse = moment(lastRemoteActivityUtcString).utc();
                        if (lastActivitySomewhereElse.diff(lastRecordedAt, 'seconds') > 0) {
                            lastRecordedAt = lastActivitySomewhereElse;
                            lastHeartbeatAt = lastRecordedAt;
                            warningAlreadyRaised = false;
                        }
                        else {
                            this.RefreshLastHeartbeatTime();
                        }
                    }

                    service.ResetRaisedWarningFlag = function () {
                        warningAlreadyRaised = false;
                    };

                    service.SetRaisedWarningFlag = function () {
                        warningAlreadyRaised = true;
                    }

                    service.GetCycleInterval = function () {
                        
                        return settings.cycleInterval;
                    };

                    service.GetAutoLogoutWarningBefore = function () {
                        return settings.autoLogoutWarningBefore;
                    };

                    return service;
                }
        ]).factory('UserActivityTracker',
            ['Heartbeat', '$interval', 'AccountLogout', '$location', '$rootScope', 'SessionActivityState', 'gettextCatalog', 'gettext',
                function (Heartbeat, $interval, AccountLogout, $location, scope, userActivity, gettextCatalog, gettext) {

                let modalInstance;
                let routine = function () {
                    userActivity.RefreshCurrentCycleTime();

                    if (userActivity.IsSafetyDelayElapsed() !== true) {
                        return;
                    }

                    if (userActivity.IsHeartbeatIntervalElapsed() !== true) {
                        return;
                    }

                    if (userActivity.IsTimeToRaiseWarning() === true) {
                        Heartbeat(
                            function (response) {
                                if (response?.data?.LastSessionActivity) {
                                    userActivity.RecordRemoteActivity(response.data.LastSessionActivity);
                                } else {
                                    userActivity.RefreshLastHeartbeatTime();
                                }

                                // Perform the second IsTimeToRaiseWarning check after Heartbeat response
                                if (userActivity.IsTimeToRaiseWarning() === true) {
                                    let message = gettextCatalog.getString(gettext("You will be automatically logged out in next {x} minutes due to inactivity."))
                                        .replace('{x}', (userActivity.GetAutoLogoutWarningBefore() / 60));
                                    modalInstance = scope.showWarningBoxWithHandle(message);
                                    userActivity.SetRaisedWarningFlag();
                                }
                            },
                            function (errorResponse) {
                                userActivity.RefreshLastRecordedTime();
                                userActivity.RefreshLastHeartbeatTime();
                            }
                        );
                    }
                };

                let isSafeToRecordActivity = function (requestConfig) {
                    // Adding X-ACTIVITY header on all requests by default unless it was set to SKIP from within the service explicitly.
                    return (requestConfig
                        && (requestConfig.headers["X-ACTIVITY"] === null || requestConfig.headers["X-ACTIVITY"] !== "SKIP")
                        && requestConfig.url.toString().includes('api/') === true
                        && userActivity.IsActivityConsolidationPeriodElapsed() === true);
                };

                return {
                    Start: function () {
                        $interval(routine, (userActivity.GetCycleInterval() * 1000)); //2h 50m 
                    },
                    RecordActivity: function (requestConfig) {
                        if (isSafeToRecordActivity(requestConfig) === true) {
                            requestConfig.headers["X-ACTIVITY"] = "MARK";
                            userActivity.RefreshLastRecordedTime();
                        }
                    }
                };
            }
        ]).service('PUtill',
        [
            'gettext', 'gettextCatalog', function(gettext, gettextCatalog) {
                let service = { };
                service.BerlinTzName = Object.freeze("Europe/Berlin");
                service.isCurrentTzAwareOfDst = function() {
                    let timeZone = moment.tz.guess(true);
                    
                    // getting year because DST rules can change
                    let year = new Date().getFullYear();
                    let startOfYear = new Date(year, 0, 1).toDateString();
                    let middleOfYear = new Date(year, 6, 1).toDateString();

                    // tz constructor is DST aware, and will use the correct offset when parsing so we can get timozone for selected dates
                    let timeZoneYearStart = moment.tz(startOfYear, timeZone).format('Z z');
                    let timeZoneYearMiddle = moment.tz(middleOfYear, timeZone).format('Z z');

                    return timeZoneYearStart !== timeZoneYearMiddle;
                };

                service.PeriodUnitMappings = Object.freeze({
                    'Day': { key: 'Day', moment: 'days' },
                    'Week': { key: 'Week', moment: 'weeks' },
                    'Year': { key: 'Year', moment: 'years' },
                    'Month': { key: 'Month', moment: 'months' },
                });

                service.getStatusClass = function(status) {
                    switch (status) {
                    case 'Completed':
                    case 'Succeeded':
                    case 'PreliminarySucceeded':
                        return "label-success";
                    case 'Failed':
                    case 'Chargeback':
                        return "label-important";
                    default:
                        return '';
                    }
                };
                service.getText = function(msg) {
                    return gettextCatalog.getString(gettext(msg));
                };
                service.addPeriod = function(period, date) {
                    let momentPeriod = (service.PeriodUnitMappings[period.Unit] || { }).moment || 'years';
                    return new Date(moment(date).add(period.Quantity, momentPeriod));
                };
                service.addDay = function(date) {
                    if(!date) { return date; }
                    return moment(date).add('days', 1).toDate();
                };
                service.getDateTranslation = function (date) {
                    let key = (service.PeriodUnitMappings[date] || { }).key;
                    let translation = key ? gettextCatalog.getString(gettext(key + '(s)')) : '';
                    return translation;
                };
                service.areDatesEqual = function (d1, d2) {
                    if (d1 === d2) return true;
                    if (d1 === undefined && d2 === undefined) return true;
                    if (d1 === null && d2 === null) return true;

                    let moment1 = moment(d1);
                    let moment2 = moment(d2);
                    if (!moment1.isValid() && !moment2.isValid()) return true;
                    if (!moment1.isValid() || !moment2.isValid()) return false;

                    return moment1.format() === moment2.format();
                };
                service.convertToDateIfString = function(value) {
                    if ((typeof value === 'string' || value instanceof String) && value)
                        return moment(value).toDate();

                    return value;
                };
                service.htmlToPlainText = function (html) {
                    return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                };
                service.normalizeUtc = function (str) {
                    return str != null ? str.replace('0000Z', 'Z') : str;
                };
                service.isTimeZero = function (date) {
                    return date instanceof Date
                        ? date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0
                        : false;
                };
                service.toShortDateString = function(date) {
                    return date ? moment(date).format('YYYY-MM-DD') : null;
                };
                service.getTimezoneAbbreviation = function(date) {
                    return date ? moment(date).tz(service.BerlinTzName).format("z") : null;
                }

                return service;
            }
        ]).service('DatepickerUtils', ['PUtill', '$locale', function(PUtill, $locale) {
            let service = { };
            service.setOptions = function (ctrl) {
                ctrl.localDate = PUtill.convertToDateIfString(ctrl.localDate);
                ctrl.minDate = PUtill.convertToDateIfString(ctrl.minDate);
                ctrl.maxDate = PUtill.convertToDateIfString(ctrl.maxDate);
                ctrl.internalModel = ctrl.localDate;

                ctrl.options = {
                    showWeeks: false,
                    maxDate: ctrl.maxDate,
                    minDate: ctrl.minDate,
                };
            }
            service.defineOpen = function(ctrl) {
                ctrl.open = function ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    ctrl.opened = true;
                }
            }
            service.defineChangeEvent = function(ctrl) {
                ctrl.$onChanges = function (changes) {
                    service.adjustMinAndMaxDateInOptionsFunc(ctrl, changes)();
                    ctrl.localDate = PUtill.convertToDateIfString(ctrl.localDate);
                };
            }
            service.defineDisabled = function(ctrl) {
                // Disable weekend selection
                // 2020.06.05 man - this is not working, just copied from old directive
                ctrl.disabled = function (date, mode) {
                    return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
                };
            }
            service.turnMinAndMaxDateToBerlin = function(ctrl) {
                if (!ctrl.skipMinDateCheck && ctrl.minDate) {
                    let berlinDate = PUtill.toShortDateString(moment(ctrl.minDate).tz(PUtill.BerlinTzName));
                    let berlinMidnight = service.parseBerlinDate(berlinDate);
                    ctrl.minDate = berlinMidnight;

                    ctrl.skipMinDateCheck = true;
                }

                if (!ctrl.skipMaxDateCheck && ctrl.maxDate) {
                    let berlinDate = PUtill.toShortDateString(moment(ctrl.maxDate).tz(PUtill.BerlinTzName));
                    let berlinMidnight = service.parseBerlinDate(berlinDate);
                    ctrl.maxDate = berlinMidnight;

                    ctrl.skipMaxDateCheck = true;
                }
            }

            service.init = function(ctrl) {
                ctrl.opened = false;
                ctrl.format = $locale.DATETIME_FORMATS.mediumDate;
                ctrl.timezone = moment().tz(PUtill.BerlinTzName).format("ZZ");
                ctrl.tooltipTimezone = function () {
                    let abbreviation = PUtill.getTimezoneAbbreviation(ctrl.localDate);
                    return PUtill.getText(abbreviation);

                    // required so the grunt task finds the strings...
                    // ReSharper disable JsUnreachableCode
                    gettext("CET"); gettext("CEST");
                    // ReSharper restore JsUnreachableCode
                };
            }
            service.adjustMinAndMaxDateInOptionsFunc = function(ctrl, changes) {
                return function () {
                    if (!changes) return;

                    if (changes.minDate && ctrl.options)
                        ctrl.options.minDate = PUtill.convertToDateIfString(ctrl.minDate);
                    if (changes.maxDate && ctrl.options)
                        ctrl.options.maxDate = PUtill.convertToDateIfString(ctrl.maxDate);
                };
            }
            service.backToBrowserTimezone = function(date) {
                if (!date || service.isAlreadyInBrowserTimezone(date)) return date;
                
                let corrected = new Date(date);
                // No need to apply an offset, UTC + Date() does the thing properly already
                if (!(typeof date === 'string' || date instanceof String) || !date.endsWith("Z"))
                {
                    let formatted = moment(date).format("YYYY-MM-DDTHH:mm:ss");
                    let zoneOfFormattedForEuropeBerlin = moment(formatted).tz(PUtill.BerlinTzName).format("ZZ");
                    let toParse = formatted + zoneOfFormattedForEuropeBerlin;
                    corrected = new Date(toParse);
                }

                service.markAsAlreadyInBrowserTimezone(corrected);
                return corrected;
            }
            service.markAsAlreadyInBrowserTimezone = function(date) {
                if (!date) return date;

                date._browserTimezoneAlreadyApplied = true;
            }
            service.isAlreadyInBrowserTimezone = function(date) {
                if (!date) return date;
                return date._browserTimezoneAlreadyApplied === true;
            }
            service.toBerlinMidnightTime = function(date) {
                if (!date) return date;

                let corrected = new Date(date);
                corrected.setHours(0, 0, 0, 0);
                return service.backToBrowserTimezone(corrected);
            };
            service.parseBerlinDate = function(dateString) {
                if (!dateString) return null;
        
                let momentOfString = moment(dateString).tz(PUtill.BerlinTzName);
                let date = momentOfString.toDate();
                return service.toBerlinMidnightTime(date);
            }
            service.toShortBerlinDateString = function(date) {
                if (!date) return null;
                if (!date._browserTimezoneAlreadyApplied)
                    throw new Error("Only dates with browser timezone mark set explicitly may be used with that method");
        
                let dateMoment = moment(date).tz(PUtill.BerlinTzName);
                return PUtill.toShortDateString(dateMoment);
            };
            service.setSearchParamsWithStringRangeAndRaiseErrorIfNeeded = function(scope, params, dateRange) {
                if ((dateRange.dateFrom || dateRange.dateTo) && (!dateRange.dateFrom || !dateRange.dateTo))
                {
                    params.dateFrom = null;
                    params.dateTo = null;
                    scope.error = true;
                } else if (dateRange.dateFrom && dateRange.dateTo) {
                    service.setSearchParamsWithStringRange(params, dateRange);
                    scope.error = false;
                }
            }
            service.setSearchParamsWithStringRange = function(params, dateRange) {
                let dateFrom = dateRange.dateFrom ? moment(dateRange.dateFrom).tz(PUtill.BerlinTzName) : null;
                let dateTo = dateRange.dateTo ? moment(dateRange.dateTo).tz(PUtill.BerlinTzName) : null;
                params.dateFrom = PUtill.toShortDateString(dateFrom);
                params.dateTo = PUtill.toShortDateString(dateTo);
            }

            // Due to a b-u-g/feature angularjs+bootstrap+... datepicker has:
            // datepicker is unable to recognize that the chosen externally picked date/the one we want to provide
            // points to CEST when applying a relative offset (consider 27.03 00:00 in Minsk which is 26.03 23:00 in Berlin, not 22:00),
            // so we need to apply that +1 offset ourselves :/ *m*a*g*i*c* that took me a whole day to figure out
            service.adjustToDst = function(date) {
                if (!date) return date;
                
                let result = service.backToBrowserTimezone(date);
                if (date && !date._dstAdjusted) {
                    let momento = moment(date);
                    let isDstInBerlin = momento.tz(PUtill.BerlinTzName).isDST();
                    if (isDstInBerlin) {
                        result = moment(momento).add(1, 'hours').toDate();
                        service.markAsAlreadyInBrowserTimezone(result);
                    }
                }

                result._dstAdjusted = true;
                return result;
            }

            return service;
        }
        ]).factory('SupportedHtmlTagsDescription',
        [
            'PUtill', 'gettext', 'gettextCatalog', '$resource', function (PUtill, gettext, gettextCatalog, $resource) {
                return {
                    get: function () {
                        let localizedText = gettextCatalog.getString(gettext("SupportedHtmlTagsDescription"));
                        let allowedTagsResource = $resource(baseUrl + 'api/v1/DocumentTemplates/AllowedTags',
                            { },
                            { get: { method: 'GET', isArray: true } });
                        let textPromise = allowedTagsResource.get().$promise.then(function (tags) {
                            tags.forEach(function (tag, index) {
                                localizedText += (index === 0 ? '' : ', ') + ' <' + tag + '>';
                            });
                            return PUtill.htmlToPlainText(localizedText);
                        });

                        return Promise.resolve(textPromise);
                    }
                };
        }]).factory('ContractRatedItems',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/ratedItems',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
            }
        ]).factory('PrepaidCard',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/PrepaidCards/:Id',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
            }
        ]).factory('RatedItems',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/ratedItems/:ratedItemId', {}, {});
            }
        ]).factory('OrdersDownloadByFilter',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/orders/downloadlink', {}, {});
            }
        ]).factory('PaymentRefundDownloadByFilter',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/paymentRefund/downloadlink', {}, {});
            }
        ]).factory('TransactionsDownloadByFilter',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/PaymentTransactions/downloadlink', {}, {});
            }
        ]).factory('WebhookEvents',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/webhookEvents/:eventId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true }
                    });
            }
        ]).factory('UserResendConfirmation',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/users/:userId/resendconfirmation', {}, {});
            }
        ]).factory('CheckPasswordStrength',
        [
            '$http', function($http) {
                return function(data, callback) {
                    $http({
                        method: "POST",
                        url: "api/v1/checkpassword",
                        data: { "password": data.password, "email": data.email, "token": data.token },
                        headers: {},
                        cache: false
                    }).then(callback);
                };
            }
        ]).factory('Throttle',
        [
            '$timeout', function($timeout) {
                function throttle(action, delay, callback) {
                    var result = {};
                    var outstandingVersion = 0; // requested by the consumer, but might not have been requested yet
                    var requestedVersion = 0; // action has been called
                    var availableVersion = 0; // response is available for this version
                    var timeout = null;

                    function request() {
                        timeout = null;
                        if (outstandingVersion === requestedVersion)
                            return;
                        requestedVersion = outstandingVersion;

                        var requestVersion = outstandingVersion;
                        action(result.outstandingRequest, callback2);

                        function callback2(response) {
                            if (requestVersion < availableVersion) // block out-of-order arrivals
                                return;
                            availableVersion = requestVersion;
                            result.response = response;
                            result.isCurrent = availableVersion === outstandingVersion;
                            if (callback)
                                callback(response);
                        }
                    }

                    result.request = function(data) {
                        result.outstandingRequest = data;
                        outstandingVersion++;
                        if (!timeout) {
                            request();
                            timeout = $timeout(request, delay);
                        }
                    }

                    return result;
                }

                return throttle;
            }
        ]).factory('ProductOrders',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/productorders', {}, {});
            }
        ]).factory('LedgerUtils', ['PUtill',
        function(PUtill) {
            return {
                getLedgerSource: function(ledgerEntry) {
                    let transactionDescriptionStart = 'Transaction: ';
                    let refundDescriptionStart = 'Refund of ';
                    let chargebackDescriptionStart = 'Chargeback of ';

                    if ((ledgerEntry.Type === 'Payment' || ledgerEntry.Type === 'DebtCollection') &&
                        ledgerEntry.Description &&
                        ledgerEntry.Description.startsWith(transactionDescriptionStart) &&
                        ledgerEntry.Description.replace(transactionDescriptionStart, '').length === 24)
                        return 'Transaction';

                    if (ledgerEntry.Type === 'Refund' &&
                        ledgerEntry.Description &&
                        ledgerEntry.Description.startsWith(refundDescriptionStart) &&
                        ledgerEntry.Description.replace(refundDescriptionStart, '').length === 24)
                        return 'Refund';

                    if (ledgerEntry.Type === 'Chargeback' &&
                        ledgerEntry.Description &&
                        ledgerEntry.Description.startsWith(chargebackDescriptionStart) &&
                        ledgerEntry.Description.replace(chargebackDescriptionStart, '').length === 24)
                        return 'Chargeback';

                    if (ledgerEntry.ReconciliationTransactionId)
                        return 'Reconciliation';

                    if (ledgerEntry.Type === 'Receivable' && ledgerEntry.Description.startsWith('Invoice: '))
                        return 'Invoice';

                    if (ledgerEntry.Type === 'Receivable' && ledgerEntry.Description.startsWith('Invoice Draft: '))
                        return 'Invoice Draft';
                    if (ledgerEntry.Type === 'Receivable' && ledgerEntry.Description.startsWith('Credit Note: '))
                        return 'Credit Note';

                    if (ledgerEntry.Type === 'Receivable' && ledgerEntry.Description.startsWith('Credit Note Draft: '))
                        return 'Credit Note Draft';

                    if (ledgerEntry.Type === 'WriteOff')
                        return 'Write-Off'

                    return '';
                },
                getLedgerDescription: function (ledgerEntry, source) {
                    if(ledgerEntry.Description == null) {
                        return '';
                    }
                    
                    if (source === 'Refund') {
                        source = 'Refund of';
                    } else if (source === 'Chargeback') {
                        source = 'Chargeback of';
                    }

                    if (source !== '') {
                        return ledgerEntry.Description.replace(source, PUtill.getText(source));
                    }

                    let adjustEntryChargebackDescription = "Adjusting entry for Chargeback";
                    let adjustEntryRefundDescription = "Adjusting entry for Refund";

                    if (ledgerEntry.Description.startsWith(adjustEntryChargebackDescription)) {
                        return ledgerEntry.Description.replace(adjustEntryChargebackDescription, PUtill.getText(adjustEntryChargebackDescription));
                    }

                    if (ledgerEntry.Description.startsWith(adjustEntryRefundDescription)) {
                        return ledgerEntry.Description.replace(adjustEntryRefundDescription, PUtill.getText(adjustEntryRefundDescription));
                    }

                    return ledgerEntry.Description;
                },
                setEntryDetails: function (ledgerEntry) {
                    let source = this.getLedgerSource(ledgerEntry);
                    ledgerEntry.entryDescription = this.getLedgerDescription(ledgerEntry, source);
                    ledgerEntry.hint = 'Detail';
                    ledgerEntry.targetLink = '';

                    if(source === 'Reconciliation'){
                        ledgerEntry.targetLink = '#/activities/reconciliationAssign/' + ledgerEntry.ReconciliationTransactionId;
                    }

                    if(source === 'Transaction'){
                        ledgerEntry.targetLink = '#/logs/payment-transactions/' + ledgerEntry.Description.replace('Transaction: ','');
                        ledgerEntry.hint = 'Transaction details';
                    }

                    if(source === 'Chargeback'){
                        ledgerEntry.targetLink = '#/logs/payment-transactions/' + ledgerEntry.Description.replace('Chargeback of ','');
                        ledgerEntry.hint = 'Transaction details';
                    }

                    if(source === 'Refund'){
                        ledgerEntry.targetLink = '#/logs/payment-refunds/' + ledgerEntry.PaymentRefundId;
                        ledgerEntry.hint = 'Refund details';
                    }

                    if(source === 'Invoice' || source === 'Write-Off' || source === 'Credit Note'){
                        ledgerEntry.targetLink = '#/invoices/' + ledgerEntry.InvoiceId;
                    }

                    if(source === 'Invoice Draft' || source === 'Credit Note Draft'){
                        ledgerEntry.targetLink = '#/invoice-drafts/' + ledgerEntry.InvoiceDraftId;
                    }
                },
                populateAdditionalDetails: function(entries) {
                    if (entries && entries.length > 0) {
                        let util = this;

                        entries.forEach(function(entry){
                            util.setEntryDetails(entry);
                        });
                    }

                    return entries;
                },
            };
        }]).factory('ContractNotesByContract',
        [
            '$resource', function($resource) {
                return $resource(baseUrl + 'api/v1/contracts/:contractId/notes/:noteId',
                    {},
                    {
                        update: { method: 'PUT', params: {} }
                    });
            }
    ]).factory('LockStateUpdater',
    [
        '$http', function($http) {
                var service = {
                    updateLockedState: function(customerId, isLocked, callback) {
                        $http({
                                method: "POST",
                                url: "/api/v1/customers/updateLockedState",
                                params: { "id": customerId, "isLocked": isLocked },
                                data: {},
                                headers: {},
                                cache: false
                            })
                            .then(callback);
                    }
                };
                return service;
            }
    ])
    .factory('AuditLog',
    [
        '$resource', function ($resource) {
            return $resource(baseUrl + 'api/v1/auditLog/:auditLogId',
                {},
                {
                    list: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                    get: { method: 'GET', params: { includeDataChanges: true } }
                });
        }
        ])
    .factory('ExternalTransactionRequestLog',
        [
            '$resource', function ($resource) {
            return $resource(baseUrl + 'api/v1/externalTransactionRequestLogs',
                {},
                {
                    get: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                });
        }
        ])
    .factory('LedgerEscalation',
    [
        '$resource', function ($resource) {
            return $resource(baseUrl + 'api/v1/ledgerEscalation/:contractId', {}, {
                query: { method: 'GET' }
            });
            }
    ]).factory('ContractDebtCollection',
    [
        '$resource', function ($resource) {
            return $resource(baseUrl + 'api/v1/contracts/:contractId/debt-collection/:action', { action: '@action' }, {
                history: { method: 'GET', params: { action: 'history' }, isArray: true },
                resend: { method: 'POST', params: { action: 'resend' } }
            });
        }
    ]).factory('Notifications',
        [
            '$resource', function ($resource) {
                return $resource(baseUrl + 'api/v1/notifications/:notificationId',
                    {},
                    {
                        query: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                    });
            }
    ]).factory('NotificationsGroups',
    [
        '$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/notificationsGroups/',
            {},
            {
                query: {method: 'GET', isArray: true},
            });
    }
    ]).factory('LegalEntity',
    ['$http', '$rootScope', '$q', function ($http, $rootScope, $q) {
        var result = {};
        var isBillwerkClient = false;

        result.isBillwerkClient = function () {
            return isBillwerkClient;
        };

        var loaded = false;
        result.reload = function () {
            if (!$http.defaults.headers.common["Authorization"]) {
                return $q.when({});
            }

            let entitiesPromise =  result.loadingEntitiesAsPromise().then(function (response) {
                if (response.data.length === 1) {
                    result.saveChosenEntity(response.data[0]);
                }
            });

            let isBillwerkClientPromise = $http({
                method: "GET",
                url: baseUrl + 'api/v1/legalEntity/isBillwerkClient',
                data: {}
            }).then(function (response) {
                isBillwerkClient = response.data;
            });

            loaded = true;

            return $q.all([entitiesPromise, isBillwerkClientPromise]);
        };

        result.loadingEntitiesAsPromise = function (queryParams) {
            return $http({
                method: "GET",
                url: baseUrl + 'api/v1/legalEntities/selectable',
                params: queryParams
            });
        }

        result.saveChosenEntity = function (entity) {
            if (entity != null && entity.Id && entity.Name){
                $rootScope.chosenEntity = entity;
                localStorage.setItem('chosenEntity', angular.toJson(entity));
            }
        }

        result.load = function () {
            if (!loaded) {
                return result.reload();
            }

            return $q.when({});
        };

        result.reload();

        return result;
    }]).factory('nationalIdValidatorService',
    [function () {
        var NATIONAL_ID_NUMBER_REGEX = {
            "DK": /^\d{6}-\d{4}$/,

            "SE": /^\d{8}-\d{4}$/,
        };

        const Autogiro = "Autogiro:PayExInvoiceService";
        const Betalingsservice = "Betalingsservice:PayExInvoiceService";

        var service = {
            isNationalIdValid: isNationalIdValid,
            getCountryCodeForPaymentMethod: getCountryCodeForPaymentMethod
        };

        function getCountryCodeForPaymentMethod(paymentMethod) {
            switch (paymentMethod) {
                case Autogiro:
                    return "SE";
                case Betalingsservice:
                    return "DK";
            }
        }

        function isNationalIdValid(countryCode, nationalId) {
            var regex = NATIONAL_ID_NUMBER_REGEX[countryCode];
            return nationalId && regex && regex.test(nationalId) === true;
        }

        return service;
    }]).factory('CustomerEmailNotificationEvents', [
        '$resource', function ($resource) {
            return $resource(baseUrl + 'api/v1/emailNotificationsTemplateTypes');
    }]).factory('SalesEntities', [
        '$resource', function ($resource) {
            return $resource(baseUrl + 'api/v1/salesentities/:salesEntityId',
                { salesEntityId: '@Id' },
                {
                    get: { method: 'GET' },
                    update: { method: 'PUT', params: {} }
                });
    }]).factory('LegalEntities', [
        '$resource', function ($resource) {
            return $resource(baseUrl + 'api/v1/legalEntities/:entityId',
                { entityId: '@Id' },
                {
                    get: { method: 'GET' },
                    update: { method: 'PUT', params: {} },
                    create: { method: 'POST', params: {} }
                });
    }]).factory('SelectableLegalEntities', [
    '$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/legalEntities/selectable',
            { },
            {
                get: { method: 'GET' }
            });
    }]).factory('DefaultSalesEntity', [
        '$resource', function ($resource) {
            return $resource(baseUrl + 'api/v1/salesentities/default',
                { },
                {
                    get: { method: 'GET' },
                });
    }]).factory('ContractUpgradeChangesMediator',

    function() {
        let service = { };

        service.recurringComponentUpdates = [];
        service.meteredComponentsUpdates = [];
        service.discountUpdates = [];
        service.ratedItemsUpdates = [];
        service.order = { };
        service.order.EmailTemplateExternalId = null;

        service.datePresetName = "";
        service.requirePayment = false;
        service.onAccount = false;
        service.currency = "";
        service.planChanged = false;
        service.trialMode = {};

        service.addRecurringComponentUpdates = function (recurringComponent) {
            service.recurringComponentUpdates.push(recurringComponent);
        }
        service.removeRecurringComponentUpdates = function (recurringComponentHashKey) {
            service.recurringComponentUpdates = removeItemByHashKey(service.recurringComponentUpdates, recurringComponentHashKey)
        }

        service.addMeteredComponentUpdates = function (meteredComponent) {
            service.meteredComponentsUpdates.push(meteredComponent);
        }
        service.removeMeteredComponentUpdates = function (meteredComponentHashKey) {
            service.meteredComponentsUpdates = removeItemByHashKey(service.meteredComponentsUpdates, meteredComponentHashKey);
        }

        service.addDiscountComponentUpdates = function (discount) {
            service.discountUpdates.push(discount);
        }
        service.removeDiscountComponentUpdates = function (discountHashKey) {
            service.discountUpdates = removeItemByHashKey(service.discountUpdates, discountHashKey);
        }

        service.addRatedItemsComponentUpdates = function (ratedItem) {
            var existingItem = service.ratedItemsUpdates.find(function (item) {
                return item.$$hashKey === ratedItem.$$hashKey;
            });
            
            if (!existingItem) {
                service.ratedItemsUpdates.push(ratedItem);
            }
        };
        service.removeRatedItemsComponentUpdates = function (ratedItemHashKey) {
            service.ratedItemsUpdates = removeItemByHashKey(service.ratedItemsUpdates, ratedItemHashKey);
        }

        const removeItemByHashKey = function (array, hashKey) {
            return array.filter(function (item) {
                return item.$$hashKey !== hashKey;
            });
        }

        service.reset = function() {
            service.recurringComponentUpdates = [];
            service.meteredComponentsUpdates = [];
            service.discountUpdates = [];
            service.ratedItemsUpdates = [];
            service.order = { };

            service.datePresetName = "";
            service.requirePayment = false;
            service.onAccount = false;
            service.currency = "";
            service.planChanged = false;
            service.trialMode = {};
        }

        return service;
    }).factory('EuropeanUnion', [
        function () {
            let service = { };

            const brexitDate = new Date('2021-01-01T00:00:00');
            const euCountries = ["AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "GR", "ES", "FI", "FR", "HR", "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI", "SK"];

            service.getEuCountries = function (dateTime) {
                let currentEuCountries = angular.copy(euCountries);

                if (dateTime < brexitDate.getTime()) {
                    currentEuCountries.push("GB");
                }

                return currentEuCountries;
            }

            service.isMember = function (country, dateTime) {
                let currentEuCountries = service.getEuCountries(dateTime);

                return currentEuCountries.includes(country);
            }

            return service;
    }]).factory('ContractUnbilledMeteredLineItemsForUpgradeProcess',
    [
        '$resource', function($resource) {
        return $resource(baseUrl +

            'api/v1/contracts/:contractId/unbilledMeteredLineItemsForUpgrade?upgradeDate=:upgradeDate',

            {}, {});
    }]).factory('CountryWhiteListSettings', [
    '$http', function($http) {
        const service = {
            get: function(locale) {
                return $http({
                    method: 'GET',
                    url: baseUrl + 'api/v1/settings/countryWhiteList?locale=' + locale
                })
            },
            save: function(data) {
                return $http({
                    method: 'PUT',
                    url: baseUrl + 'api/v1/settings/countryWhiteList',
                    data: data
                });
            }
        };
        return service;
        }]).factory('BulkUpdateContractsFilterBag', function() {
        let bag = { };
        bag.clean = function() { bag.filter = null; }
        bag.setFilter = function(filter) { bag.filter = filter; }

        return bag;
        }).factory('RevenueWriteOffHelper', ['DatepickerUtils', 'PUtill', function (DatepickerUtils, PUtill) {
        let service = { };
        service.getBookingDateConstraints = function (accountingSettingsFinalizedDate) {
            function bookingDateToMidnight() {
                let berlinDateString = DatepickerUtils.toShortBerlinDateString(constraints.bookingDate);
                constraints.bookingDate = DatepickerUtils.parseBerlinDate(berlinDateString);
            }
            
            let constraints = {
                bookingDate : null,
                maxDate : null,
                minDate : null,
                bookingDateIsInClosedPeriod : false,
            };

            let nowMoment = moment();
            constraints.maxDate = moment(nowMoment).tz(PUtill.BerlinTzName).endOf('month').toDate();

            let finalizedDate = DatepickerUtils.parseBerlinDate(accountingSettingsFinalizedDate);
            let finalizedDateMoment = finalizedDate ? moment(finalizedDate).tz(PUtill.BerlinTzName) : null;

            let bookingDate = nowMoment.toDate();
            DatepickerUtils.markAsAlreadyInBrowserTimezone(bookingDate);
            
            if (finalizedDateMoment === null) {
                constraints.bookingDate = bookingDate;
                bookingDateToMidnight();
                return constraints;
            }
            // Selectable MinDate should be in the next open period - FinalizedDate + 1 day
            constraints.minDate = moment(finalizedDateMoment).add(1, 'days').toDate();
            if (finalizedDateMoment.isAfter(moment(constraints.maxDate))) {
                constraints.bookingDate = null;
                constraints.bookingDateIsInClosedPeriod = true;
            }
            else {
                constraints.bookingDate = bookingDate >= constraints.minDate && bookingDate <= constraints.maxDate
                    ? bookingDate : constraints.minDate;
            }

            bookingDateToMidnight();
            return constraints;
        }

        return service;
    }]).factory('TaxRequests',
        [
            '$resource', function ($resource) {
                return $resource(baseUrl + 'api/v1/taxRequests/:taxRequestId',
                    {},
                    {
                        list: { method: 'GET', params: { skip: 0, take: 100 }, isArray: true },
                        get: { method: 'GET', params: { includeDataChanges: true } }
                    });
            }
    ]).factory('EInvoicingDispatchStatusDisplayService', function(){
        let service = {};

        service.dispatchStatusClass = function (invoice) {
            return {
                ToBeSent: 'label-inverse',
                Initiated: 'label-inverse',
                Pending: 'label-warning',
                Succeeded: 'label-success',
                Failed: 'label-important',
            }[invoice.EInvoicingDispatchStatus] || "";
        };

        service.dispatchStatusLabel = function (invoice) {
            return {
                ToBeSent: 'To Be Sent',
                Initiated: 'Initiated',
                Pending: 'Pending',
                Succeeded: 'Succeeded',
                Failed: 'Failed',
            }[invoice.EInvoicingDispatchStatus] || "";
        };

        service.getLastPollingDate = function (invoice) {
            return invoice.EInvoicingDispatchStatus !== 'ToBeSent' ? invoice.EInvoicingLastPolledAt : null;
        };

        return service;
    }).factory('ReconciliationImportHistoryService', ['$rootScope','gettext','gettextCatalog','pdateFilter',function($rootScope, gettext, gettextCatalog, pdateFilter){
        let service = {};

        service.RECONCILIATION_IMPORT_MODE = Object.freeze({
            'Undefined': 'Undefined',
            'ManualImport': 'ManualImport',
            'DownloadFromBank': 'DownloadFromBank',
        });

        service.RECONCILIATION_IMPORT_STATUS = Object.freeze({
            'Undefined': 'Undefined',
            'InProgress': 'InProgress',
            'Finished': 'Finished',
            'Failed': 'Failed',
        });

        service.toggleImportInfoVisibility = function(importItem) {
            importItem.show = !importItem.show;
        };

        function ReconciliationImportModeHeader(id, name){
            this.id = id;
            this.name = name;
        }

        let reconciliationImportModeHeaders = [
            new ReconciliationImportModeHeader(service.RECONCILIATION_IMPORT_MODE.ManualImport, gettextCatalog.getString(gettext('Manual file import'))),
            new ReconciliationImportModeHeader(service.RECONCILIATION_IMPORT_MODE.DownloadFromBank, gettextCatalog.getString(gettext('Bank statement from {0} requested for the period {1} - {2}'))),
            new ReconciliationImportModeHeader(service.RECONCILIATION_IMPORT_MODE.Undefined, gettextCatalog.getString(gettext('Undefined'))),
        ];

        service.setHistoryItemHeader = function(importItem)
        {
            let modeHeader = reconciliationImportModeHeaders.find(function (mode) {
                return mode.id === importItem.ImportType;
            });

            let name = modeHeader.name;
            if(modeHeader.id == service.RECONCILIATION_IMPORT_MODE.DownloadFromBank)
            {
                name = name.replace("{0}", importItem.DownloadOptions.BankName)
                        .replace("{1}", pdateFilter(importItem.DownloadOptions.From, 'shortDate'))
                        .replace("{2}", pdateFilter(importItem.DownloadOptions.To, 'shortDate'));
            }
            return name;
        };

        service.IsListEmpty = function(list)
        {
            return !list || list.length == 0;
        };

        service.getProcessingStatusClass = function(statusValue)
        {
            switch (statusValue) {
                case service.RECONCILIATION_IMPORT_STATUS.Finished:
                    return "label-success";
                case service.RECONCILIATION_IMPORT_STATUS.InProgress:
                    return "label-info";
                case service.RECONCILIATION_IMPORT_STATUS.Failed:
                    return "label-important";
                case service.RECONCILIATION_IMPORT_STATUS.Undefined:
                    return "label-warning";
                default:
                    return "";
            }
        }

        service.showSpecificError = function(errorMessage) {

            let header = gettextCatalog.getString(gettext('Error!'));
            let message = gettextCatalog.getString(gettext(errorMessage));
            $rootScope.onlyOk(header, message);
        };

        service.getStatusFileColumnMessage = function(item) {

            return item && item.Status && item.Status === 'Succeeded' && item.Files && item.Files.length === 0;
        }
        
        service.toggleOpenedItem = function(openedItems, itemId) {
            if(!openedItems.includes(itemId)) {
                openedItems.push(itemId);
            }
            else {
                var index = openedItems.indexOf(itemId);
                if (index > -1) {
                    openedItems.splice(index, 1);
                }           
            }
        }

        service.processPreviouslyOpenedElements = function(importLog, openedItems) {
            var entriesToOpen = importLog.filter(x => openedItems.includes(x.Id));
            for(var i = 0; i < entriesToOpen.length; i++) {
                entriesToOpen[i].show = true;
            }       
        }

        service.areAllItemsInTerminalPhase = function(data) {
            var inProgressItems = data.filter(x => x.Status === "InProgress");
            return inProgressItems.length === 0;
        }

        return service;
    }]).factory('BlEbicsAvailabilityService', ['ThirdPartyIntegrationSettings','Features', function(ThirdPartyIntegrationSettings,Features){
        let service = {};

        let ebicsAvailable;
        let downloadReconciliationAutomatically;
        service.requestEbicsAvailableFlag = function (readyFunc) {
            var integrations = ThirdPartyIntegrationSettings.query({}, function () {
                if (integrations) {
                    for (let i = 0; i < integrations.length; i++) {
                        let item = integrations[i];
                        if (item.ThirdPartyIntegration === 'BlEbics') {
                            ebicsAvailable = item.Active === true;
                            downloadReconciliationAutomatically = item.AutomaticProcessingSettings && item.AutomaticProcessingSettings.DownloadReconciliationAutomatically;
                            if (readyFunc) readyFunc(ebicsAvailable);
                            return ebicsAvailable;
                        }
                    }
                }
                if (readyFunc) readyFunc(ebicsAvailable);
            });            
        };        

        service.isEbicsAvailable = function () {
            return Features.features.BlEbics === true && ebicsAvailable === true;
        };

        service.isEbicsDownloadReconciliationAutomatically = function () {
            return Features.features.BlEbics === true && downloadReconciliationAutomatically === true;
        };
        
        return service;
    }])
    .factory('BlEbicsProtocol',
        [
            '$resource', function ($resource) {
                return $resource(baseUrl + 'api/v1/blEbicsProtocols',
                    {},
                    {

                        list: { method: 'GET', params: { }, isArray: true }

                    });
            }])
    .factory('BulkUpdatesNavigationHelper',
        ['$location', function ($location) {
            let service = {};

            service.redirectToAction = function (action) {
                if (action === 'Cancel contracts')
                    $location.path("/activities/bulk-cancel-contracts");
                if (action === 'Up-/Downgrade contracts')
                    $location.path("/activities/bulk-upgrade-contracts");
            };

            return service;
        }])
    .factory('ContractPauseService',
        [
            '$http', function ($http) {
            var contractApiUrl = 'api/v1/contracts/';
            return {
                resume: function (contractId, pauseId, resumeDate) {
                    return $http({
                        method: 'POST',
                        url: baseUrl + contractApiUrl + contractId + '/resume',
                        data: {ResumeDate: resumeDate, PauseId: pauseId},
                        cache: false,
                        headers: {}
                    });
                },
                pause: function (contractId, pauseContractData) {
                    return $http({
                        method: 'POST',
                        url: baseUrl + contractApiUrl + contractId + '/pause',
                        data: pauseContractData,
                        cache: false,
                        headers: {}
                    });
                },
                pausePreview: function (contractId, pauseContractData) {
                    return $http({
                        method: "POST",
                        url: baseUrl + contractApiUrl + contractId + '/pausePreview',
                        params: null,
                        data: pauseContractData,
                        headers: {},
                        cache: false
                    });
                }
            };
        }])
    .factory('WriteOff',['$http', '$q', function ($http, $q) {
        return {        
            get: function(take) {
                const paginationOptions = take?"?take="+take:"";                    
                return $http({"method": "GET", url: baseUrl + "api/v1/writeOffs"+paginationOptions, cache: false});                
                }
            };    
        }])
    .factory('ThirdPartyIntegrationSettingsBlEbicsCheckPermissions',
        [
            '$http', function ($http) {
                var ebicsApiUrl = 'api/v1/thirdPartyIntegrationSettings/BlEbics/';
                return {
                    refreshUserPermissions: function() {
                        return $http({
                            method: 'POST',
                            url: baseUrl + ebicsApiUrl + 'RefreshUserPermissions',
                            //data: null,
                            cache: false,
                            headers: {}
                        });
                    },
                    updateEbicsConfiguration: function(configuration) {
                        return $http({
                            method: 'PUT',
                            url: baseUrl + ebicsApiUrl + 'UpdateEbicsConfiguration',
                            data: configuration,
                            cache: false,
                            headers: {}
                        });                        
                    },
                    updateBankKeys: function() {
                        return $http({
                            method: 'POST',
                            url: baseUrl + ebicsApiUrl + 'UpdateBankKeys',
                            cache: false,
                            headers: {}
                        });
                    }
                };
            }
        ])
    .factory('PaymentExportService',
    [
        '$http', function ($http) {
        
        return {
            getPaymentExportFormats: function () {
                return this.getDebitFormats().concat(this.getCreditFormats());
            },
            getDebitFormats: function() {
                return [
                    this.createFormatDropDownItem("Pain00800102", "SEPA XML Direct Debit (pain.008.001.02)"),
                    this.createFormatDropDownItem("Pain00800108", "SEPA XML Direct Debit (pain.008.001.08)"),
                    this.createFormatDropDownItem("Pain00800109", "SEPA XML Direct Debit (pain.008.001.09)"), 
                ];
            },
            getCreditFormats: function() {
                return [ 
                    this.createFormatDropDownItem("Pain00100103", "SEPA XML Refund (pain.001.001.03)"),
                    this.createFormatDropDownItem("Pain00100109", "SEPA XML Refund (pain.001.001.09)")
                ];
            },
            createFormatDropDownItem: function(id, name) {
                function ExportFormat(id, name) {
                    this.id = id;
                    this.name = name;                        
                }
                return new ExportFormat(id, name);
            },
            getEbicsAutomaticProcessingSettings: function() {
                return $http({
                    method: 'GET',
                    url: baseUrl + 'api/v1/thirdPartyIntegrationSettings/BlEbics/AutomaticProcessingSettings',
                    cache: false,
                    headers: {}
                });                        
            },
            getSepaXmlExportFormats: function() {
                return $http({
                    method: 'GET',
                    url: baseUrl + 'api/v1/paymentProviderSettings/SepaXml/PaymentExportFormats',
                    cache: false,
                    headers: {}
                });
            },                                
        };
    }])
    .factory('VatIdService', function () {
        return {
            validate: function(value, countryCode) {
                const VAT_ID_REGEX = {
                    "AT": /^ATU[A-Z0-9]{8,8}$/,
                    "BE": /^BE[0-9]{10,10}$|^BE[0]{1,1}[0-9]{9,9}$/,
                    "BG": /^BG[0-9]{9,10}$/,
                    "CH": /^CHE-?[0-9]{3,3}.?[0-9]{3,3}.?[0-9]{3,3}$/,
                    "CY": /^CY[0-9]{8,8}[A-Z]{1,1}$/,
                    "CZ": /^CZ[0-9]{8,10}$/,
                    "DE": /^DE[0-9]{9,9}$/,
                    "DK": /^DK[0-9]{8,8}$/,
                    "EE": /^EE[0-9]{9,9}$/,
                    "EL": /^EL[0-9]{9,9}$/,
                    "ES": /^ES[A-Z0-9]{1,1}[0-9]{7,7}[A-Z0-9]{1,1}$/,
                    "FI": /^FI[0-9]{8,8}$/,
                    "FR": /^FR[A-Z0-9]{2,2}[0-9]{9,9}$/,
                    "GB": /^GB[0-9]{9,9}$|^GB[0-9]{12,12}$|^GBGD[0-9]{3,3}$|^GBHA[0-9]{3,3}$/,
                    "XI": /^XI[0-9]{9,9}$|^XI[0-9]{12,12}$|^XIGD[0-9]{3,3}$|^XIHA[0-9]{3,3}$/,
                    "HR": /^HR[0-9]{11,11}$/,
                    "HU": /^HU[0-9]{8,8}$/,
                    "IE": /^IE[0-9]{1,1}[A-Z0-9]{1,1}[0-9]{5,5}[A-Z]{1,1}$|^IE[0-9]{7,7}[A-W]{1,1}[A-I]{1,1}$/,
                    "IT": /^IT[0-9]{11,11}$/,
                    "LT": /^LT[0-9]{9,9}$|^LT[0-9]{12,12}$/,
                    "LU": /^LU[0-9]{8,8}$/,
                    "LV": /^LV[0-9]{11,11}$/,
                    "MT": /^MT[0-9]{8,8}$/,
                    "NL": /^NL[A-Z0-9]{9,9}B[A-Z0-9]{2,2}$/,
                    "PL": /^PL[0-9]{10,10}$/,
                    "PT": /^PT[0-9]{9,9}$/,
                    "RO": /^RO[1-9]{1,1}[0-9]{1,9}$/,
                    "SE": /^SE[0-9]{12,12}$/,
                    "SI": /^SI[0-9]{8,8}$/,
                    "SK": /^SK[0-9]{10,10}$/,
                    "NO": /^NO[0-9]{9,9}MVA$/
                };

                if (value && value.length >= 4) {
                    const valueCountryCode = value.substring(0, 2).toUpperCase();
                    let regex = VAT_ID_REGEX[valueCountryCode];
                    const isVatIdValid = regex && regex.test(value);

                    if (countryCode) {
                        if (!isVatIdValid) return false;

                        let valueCountryCode = value.substring(0, 2).toUpperCase();
                        if (valueCountryCode === "EL")
                            valueCountryCode = "GR";
                        return countryCode === valueCountryCode;
                    }
                    else return isVatIdValid;
                }
                return value == null || value === "";
            }
        };
    })
    .factory('CommonObjects', function () {
        return {
            BlankAttachment: {
                get: function () {
                    return {
                        Id: '000000000000000000000000',
                        Files: {
                            '_c':
                            {
                                FileId: '000000000000000000000000',
                                FileName: '',
                                FileSize: ''
                            }
                        }
                    };
                }
            }
        };
    }).factory('StripeDisconnect',
    [
        '$http', function ($http){
        const resource = baseUrl + 'api/v1/paymentProviderSettings/stripe/disconnect';
        return {            
            disconnect: function(){
                return $http({
                    method: "POST",
                    cache: false,
                    url: resource,
                })},
        };
    }])
    .factory('ManualPaymentRun',
        [
            '$resource', function($resource) {
            return $resource('',
                {},
                {
                    getState: {method: 'GET', url: baseUrl + 'api/v1/ManualPaymentRun/state'},
                    trigger: {method: 'POST', url: baseUrl + 'api/v1/ManualPaymentRun/trigger'},
                    cancel: {method: 'POST', url: baseUrl + 'api/v1/ManualPaymentRun/cancel'},
                })
        }
        ]
    );
